import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { getImageUrl } from '../utils/imageUtils';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { PasswordInput } from '../components/ui/password-input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
// Removed Tabs components - using conditional rendering instead
import { ScrollArea } from '../components/ui/scroll-area';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Badge } from '../components/ui/badge';
import { toast } from 'sonner';
import { ArrowLeft, UserPlus, Trash2, GamepadIcon, Activity, Upload, Search, Crown, Image as ImageIcon, Edit, MessageSquare, Database, User, Users, Shield, AlertTriangle, MailCheck, Settings, Download, Save, Eye, EyeOff, Phone, Coins } from 'lucide-react';
import { Textarea } from '../components/ui/textarea';
import { useNavigate } from 'react-router-dom';

const SuperAdminDashboard = ({ user }) => {
  const navigate = useNavigate();
  const [staff, setStaff] = useState([]);
  const [games, setGames] = useState([]);
  const [pmLogs, setPmLogs] = useState([]);
  const [currentAd, setCurrentAd] = useState(null);
  const [createStaffOpen, setCreateStaffOpen] = useState(false);
  const [createGameOpen, setCreateGameOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [newStaff, setNewStaff] = useState({ username: '', email: '', password: '' });
  const [newGame, setNewGame] = useState({ name: '', url: '', description: '' });
  
  // Staff permissions states
  const [permissionsDialogOpen, setPermissionsDialogOpen] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [staffPermissions, setStaffPermissions] = useState({
    can_create_users: false,
    can_remove_users: false,
    can_ban_users: false,
    can_view_chat_logs: false,
    can_view_room_logs: false,
    can_manage_rooms: false,
    can_grant_email_verification: false
  });
  const [adUrl, setAdUrl] = useState('');
  
  // Footer management state
  const [footerLinks, setFooterLinks] = useState([
    { label: 'Premium', url: '/premium' },
    { label: 'Contact', url: '/feedback' },
    { label: 'Sign In', url: '/auth' }
  ]);
  const [copyrightText, setCopyrightText] = useState('');

  // Active tab for side panel navigation
  const [activeTab, setActiveTab] = useState('staff');
  const [avatarTab, setAvatarTab] = useState('male');
  const [chatLogTab, setChatLogTab] = useState('public');
  
  // New feature states
  const [maleAvatars, setMaleAvatars] = useState([]);
  const [femaleAvatars, setFemaleAvatars] = useState([]);
  const [uploadingAvatar, setUploadingAvatar] = useState(false);
  const [indexContent, setIndexContent] = useState({});
  const [editingSection, setEditingSection] = useState('');
  const [editContent, setEditContent] = useState('');
  const [userSearchQuery, setUserSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [passwordSearchQuery, setPasswordSearchQuery] = useState('');
  const [passwordSearchResults, setPasswordSearchResults] = useState([]);
  const [selectedPasswordUser, setSelectedPasswordUser] = useState(null);
  const [adminResetPassword, setAdminResetPassword] = useState({ newPassword: '', confirmPassword: '' });
  const [resettingPassword, setResettingPassword] = useState(false);
  const [logSearchUserId, setLogSearchUserId] = useState('');
  const [chatLogs, setChatLogs] = useState(null);
  
  // New states for Rooms and Users tabs
  const [rooms, setRooms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [bannedUsers, setBannedUsers] = useState([]);
  
  // Bulk delete states
  const [selectedUsers, setSelectedUsers] = useState([]);
  
  // PM Logs enhanced states
  const [pmUsersList, setPmUsersList] = useState([]);
  const [selectedPmUser, setSelectedPmUser] = useState(null);
  const [pmFriendsList, setPmFriendsList] = useState([]);
  const [selectedPmFriend, setSelectedPmFriend] = useState(null);
  const [pmConversation, setPmConversation] = useState([]);
  
  // Premium users state
  const [premiumUsers, setPremiumUsers] = useState([]);
  const [premiumRequests, setPremiumRequests] = useState([]);
  
  // Database viewer states
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [collectionData, setCollectionData] = useState(null);
  
  // Performance metrics states
  const [performanceMetrics, setPerformanceMetrics] = useState(null);
  const [loadingMetrics, setLoadingMetrics] = useState(false);
  const [autoRefreshMetrics, setAutoRefreshMetrics] = useState(true);
  
  // PHASE 4 & 6: Media Security and System Health states
  const [mediaSecurityStats, setMediaSecurityStats] = useState(null);
  const [systemHealthData, setSystemHealthData] = useState(null);
  const [loadingMediaSecurity, setLoadingMediaSecurity] = useState(false);
  const [loadingSystemHealth, setLoadingSystemHealth] = useState(false);
  
  // ENV variables states
  const [envVariables, setEnvVariables] = useState({ backend: {}, frontend: {} });
  const [loadingEnv, setLoadingEnv] = useState(false);
  const [editingEnv, setEditingEnv] = useState({ backend: {}, frontend: {} });
  const [envTarget, setEnvTarget] = useState('backend');
  
  // Theme and Font states
  const [globalTheme, setGlobalTheme] = useState({
    font_size: 14,
    font_color: '#000000',
    notification_color: '#3B82F6',
    chat_bubble_own: '#2563EB',
    chat_bubble_other: '#FFFFFF'
  });
  
  // Email Verification Requests state
  const [verificationRequests, setVerificationRequests] = useState([]);
  
  // File Editor state
  const [indexHtmlContent, setIndexHtmlContent] = useState('');
  const [indexHtmlPath, setIndexHtmlPath] = useState('');
  const [savingFile, setSavingFile] = useState(false);
  const [applyingUpdates, setApplyingUpdates] = useState(false);
  
  // Meta Tags state
  const [metaTagsContent, setMetaTagsContent] = useState('');
  const [metaTagsLastUpdated, setMetaTagsLastUpdated] = useState(null);
  const [savingMetaTags, setSavingMetaTags] = useState(false);
  
  // Database Editor state
  const [dbCollections, setDbCollections] = useState([]);
  const [selectedDbCollection, setSelectedDbCollection] = useState(null);
  const [dbCollectionData, setDbCollectionData] = useState([]);
  const [dbCollectionTotal, setDbCollectionTotal] = useState(0);

  // OTP Monitoring states
  const [otpStatus, setOtpStatus] = useState(null);
  const [loadingOtpStatus, setLoadingOtpStatus] = useState(false);
  const [autoRefreshOtp, setAutoRefreshOtp] = useState(true);

  // Endpoints Health states
  const [endpointsHealth, setEndpointsHealth] = useState(null);
  const [loadingEndpointsHealth, setLoadingEndpointsHealth] = useState(false);
  
  // Service Control states
  const [services, setServices] = useState([]);
  const [serviceLogs, setServiceLogs] = useState('');
  const [selectedServiceForLogs, setSelectedServiceForLogs] = useState('backend');
  const [selectedLogType, setSelectedLogType] = useState('out');
  const [loadingServices, setLoadingServices] = useState(false);

  // Badge Management states
  const [badges, setBadges] = useState([]);
  const [loadingBadges, setLoadingBadges] = useState(false);
  const [createBadgeOpen, setCreateBadgeOpen] = useState(false);
  const [newBadge, setNewBadge] = useState({ name: '', description: '', tag: '', emoji_sequence: '' });
  
  // ENV variable viewing state
  const [showMaskedValues, setShowMaskedValues] = useState({});

  // Traffic Report states
  const [trafficReport, setTrafficReport] = useState(null);
  const [loadingTraffic, setLoadingTraffic] = useState(false);

  // Audit Logs state
  const [auditLogs, setAuditLogs] = useState([]);
  const [loadingAuditLogs, setLoadingAuditLogs] = useState(false);
  const [feedback, setFeedback] = useState([]);
  const [loadingFeedback, setLoadingFeedback] = useState(false);

  // Notifications/Banner state
  const [notifications, setNotifications] = useState([]);
  const [newNotification, setNewNotification] = useState({
    title: '',
    message: '',
    target_type: 'all', // all, room, user
    target_id: '',
    duration_hours: 24,
    color: '#3B82F6'
  });
  const [loadingNotifications, setLoadingNotifications] = useState(false);

  // Leaderboard state
  const [leaderboard, setLeaderboard] = useState([]);
  const [loadingLeaderboard, setLoadingLeaderboard] = useState(false);
  const [leaderboardFilter, setLeaderboardFilter] = useState('coins'); // coins, logins, friends, rooms
  const [voipLogs, setVoipLogs] = useState([]);
  const [coinUsers, setCoinUsers] = useState([]);
  const [coinAction, setCoinAction] = useState({ user_id: '', amount: 100, reason: 'manual adjustment' });
  const [ipMonitor, setIpMonitor] = useState({ summary: {}, multi_ip_users: [], shared_ip_groups: [], recent_logs: [] });
  const formatUserRef = (userId) => {
    if (!userId) return '-';
    const userMatch = (allUsers || []).find((u) => u?.id === userId);
    if (!userMatch) return userId;
    const name = userMatch.display_name || userMatch.username || userMatch.id;
    const usernamePart = userMatch.username ? `@${userMatch.username}` : '';
    return `${name}${usernamePart ? ` (${usernamePart})` : ''} [${userMatch.id}]`;
  };

  // Custom Fonts state
  const [customFonts, setCustomFonts] = useState([]);
  const [uploadingFont, setUploadingFont] = useState(false);

  // Ads Script Management state
  const [adScripts, setAdScripts] = useState([]);
  const [newAdScript, setNewAdScript] = useState({
    script_code: '',
    target_page: 'landing',
    position: 'footer',
    is_active: true
  });

  useEffect(() => {
    loadData();
  }, []);

  // Load premium users and requests when Premium tab is active
  useEffect(() => {
    if (activeTab === 'premium') {
      loadPremiumUsers();
      loadPremiumRequests();
    }
  }, [activeTab]);

  // Load verification requests when verification tab is active
  useEffect(() => {
    if (activeTab === 'verification') {
      loadVerificationRequests();
    }
  }, [activeTab]);

  const loadData = async () => {
    try {
      // Load data with individual error handling
      const promises = [
        axios.get(`${API}/staff`).catch(e => ({ data: [] })),
        axios.get(`${API}/games`).catch(e => ({ data: [] })),
        axios.get(`${API}/logs/pm`).catch(e => ({ data: [] })),
        axios.get(`${API}/ads/current`).catch(e => ({ data: null })),
        axios.get(`${API}/admin/avatars/male`).catch(e => ({ data: [] })),
        axios.get(`${API}/admin/avatars/female`).catch(e => ({ data: [] })),
        axios.get(`${API}/admin/index-content`).catch(e => ({ data: [] })),
        axios.get(`${API}/rooms`).catch(e => ({ data: [] })),
        axios.get(`${API}/admin/users`).catch(e => ({ data: [] })),
        axios.get(`${API}/admin/theme/global`).catch(e => ({ data: {} })),
        axios.get(`${API}/admin/fonts`).catch(e => ({ data: [] })),
        axios.get(`${API}/admin/users/premium`).catch(e => ({ data: [] })),
        axios.get(`${API}/admin/voip/logs`).catch(e => ({ data: [] })),
        axios.get(`${API}/admin/coins/users`).catch(e => ({ data: [] }))
      ];
      
      const [staffRes, gamesRes, pmLogsRes, adRes, maleAvatarsRes, femaleAvatarsRes, indexContentRes, roomsRes, usersRes, themeRes, fontsRes, premiumUsersRes, voipLogsRes, coinUsersRes] = await Promise.all(promises);
      
      setStaff(staffRes.data || []);
      setGames(gamesRes.data || []);
      setPmLogs(pmLogsRes.data || []);
      setCurrentAd(adRes.data);
      if (adRes.data) {
        setAdUrl(adRes.data.ad_url || '');
      }
      
      // Load footer content
      loadFooterContent();
      setMaleAvatars(maleAvatarsRes.data || []);
      setFemaleAvatars(femaleAvatarsRes.data || []);
      setRooms(roomsRes.data || []);
      setAllUsers(usersRes.data || []);
      setGlobalTheme(themeRes.data || globalTheme);
      setPremiumUsers(premiumUsersRes.data || []);
      setVoipLogs(voipLogsRes.data || []);
      setCoinUsers(coinUsersRes.data || []);
      
      // Convert index content array to object for easy access
      const contentObj = {};
      if (indexContentRes.data && Array.isArray(indexContentRes.data)) {
        indexContentRes.data.forEach(item => {
          contentObj[item.section] = item.content;
        });
      }
      setIndexContent(contentObj);
      
      toast.success('Dashboard loaded successfully');
    } catch (error) {
      console.error('Dashboard load error:', error);
      toast.error('Failed to load some dashboard data');
    } finally {
      setLoading(false);
    }
  };

  const loadOtpStatus = async () => {
    try {
      setLoadingOtpStatus(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/otp-status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOtpStatus(response.data);
    } catch (error) {
      console.error('Failed to load OTP status:', error);
      toast.error('Failed to load OTP monitoring data');
    } finally {
      setLoadingOtpStatus(false);
    }
  };

  const loadPerformanceMetrics = async () => {
    try {
      setLoadingMetrics(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/performance-metrics`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPerformanceMetrics(response.data);
    } catch (error) {
      console.error('Failed to load performance metrics:', error);
      toast.error('Failed to load performance metrics');
    } finally {
      setLoadingMetrics(false);
    }
  };

  const loadEndpointsHealth = async () => {
    try {
      setLoadingEndpointsHealth(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/endpoints-health`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEndpointsHealth(response.data);
    } catch (error) {
      console.error('Failed to load endpoints health:', error);
      toast.error('Failed to load endpoints health data');
    } finally {
      setLoadingEndpointsHealth(false);
    }
  };

  const loadServices = async () => {
    try {
      setLoadingServices(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/service-status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setServices(response.data.services || []);
    } catch (error) {
      console.error('Failed to load services:', error);
      toast.error('Failed to load service status');
    } finally {
      setLoadingServices(false);
    }
  };

  const controlService = async (service, action) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API}/admin/service-control`, 
        { service, action },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.data.success) {
        toast.success(`${service} ${action} successful`);
        loadServices(); // Reload service status
      } else {
        toast.error(`Failed to ${action} ${service}: ${response.data.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error(`Failed to ${action} ${service}:`, error);
      toast.error(`Failed to ${action} ${service}`);
    }
  };

  const loadServiceLogs = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/service-logs`, {
        params: {
          service: selectedServiceForLogs,
          log_type: selectedLogType,
          lines: 100
        },
        headers: { Authorization: `Bearer ${token}` }
      });
      setServiceLogs(response.data.content || '');
    } catch (error) {
      console.error('Failed to load service logs:', error);
      toast.error('Failed to load service logs');
    }
  };

  const loadBadges = async () => {
    try {
      setLoadingBadges(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/badges`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBadges(response.data.badges || []);
    } catch (error) {
      console.error('Failed to load badges:', error);
      toast.error('Failed to load badges');
    } finally {
      setLoadingBadges(false);
    }
  };

  const createBadge = async () => {
    try {
      if (!newBadge.emoji_sequence || !newBadge.emoji_sequence.trim()) {
        toast.error('Please enter emoji sequence for the badge');
        return;
      }

      const formData = new FormData();
      formData.append('name', newBadge.name);
      formData.append('description', newBadge.description);
      formData.append('tag', newBadge.tag);
      formData.append('emoji_sequence', newBadge.emoji_sequence);

      const token = localStorage.getItem('token');
      await axios.post(`${API}/admin/badges`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success('Badge created successfully');
      setCreateBadgeOpen(false);
      setNewBadge({ name: '', description: '', tag: '', emoji_sequence: '' });
      loadBadges();
    } catch (error) {
      console.error('Failed to create badge:', error);
      toast.error(error.response?.data?.detail || 'Failed to create badge');
    }
  };

  const deleteBadge = async (badgeId) => {
    if (!window.confirm('Are you sure you want to delete this badge?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/admin/badges/${badgeId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Badge deleted successfully');
      loadBadges();
    } catch (error) {
      console.error('Failed to delete badge:', error);
      toast.error('Failed to delete badge');
    }
  };

  const loadTrafficReport = async () => {
    try {
      setLoadingTraffic(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/traffic-report`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTrafficReport(response.data);
    } catch (error) {
      console.error('Failed to load traffic report:', error);
      toast.error('Failed to load traffic report');
    } finally {
      setLoadingTraffic(false);
    }
  };

  // Auto-refresh performance metrics every 10 seconds when on performance tab

  const loadEnvVariables = async () => {
    try {
      setLoadingEnv(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/env-variables`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEnvVariables(response.data);
      setEditingEnv(response.data);
    } catch (error) {
      console.error('Failed to load env variables:', error);
      toast.error('Failed to load environment variables');
    } finally {
      setLoadingEnv(false);
    }
  };

  const updateEnvVariables = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/admin/env-variables`, {
        target: envTarget,
        variables: editingEnv[envTarget]
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(`${envTarget} environment variables updated successfully`);
      loadEnvVariables();
    } catch (error) {
      console.error('Failed to update env variables:', error);
      toast.error(error.response?.data?.detail || 'Failed to update environment variables');
    }
  };

  const exportEnvVariables = async (target) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/env-variables/export?target=${target}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Create download link
      const blob = new Blob([response.data.content], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = response.data.filename;
      a.click();
      window.URL.revokeObjectURL(url);
      
      toast.success('Environment variables exported successfully');
    } catch (error) {
      console.error('Failed to export env variables:', error);
      toast.error('Failed to export environment variables');
    }
  };

  // PHASE 4: Load Media Security Stats
  const loadMediaSecurityStats = async () => {
    try {
      setLoadingMediaSecurity(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/media-security-stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMediaSecurityStats(response.data);
    } catch (error) {
      console.error('Failed to load media security stats:', error);
      toast.error('Failed to load media security statistics');
    } finally {
      setLoadingMediaSecurity(false);
    }
  };

  // PHASE 6: Load System Health
  const loadSystemHealth = async () => {
    try {
      setLoadingSystemHealth(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/system-health`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSystemHealthData(response.data);
    } catch (error) {
      console.error('Failed to load system health:', error);
      toast.error('Failed to load system health data');
    } finally {
      setLoadingSystemHealth(false);
    }
  };

  // Auto-refresh OTP status every 30 seconds when on OTP monitoring tab
  useEffect(() => {
    if (activeTab === 'otp-monitoring' && autoRefreshOtp) {
      loadOtpStatus(); // Load immediately
      const interval = setInterval(loadOtpStatus, 30000); // Refresh every 30 seconds
      return () => clearInterval(interval);
    }
  }, [activeTab, autoRefreshOtp]);

  // Load System Health when tab is active
  useEffect(() => {
    if (activeTab === 'system-health') {
      loadSystemHealth();
    }
  }, [activeTab]);

  // Load endpoints health when tab is active
  useEffect(() => {
    if (activeTab === 'endpoints-health') {
      loadEndpointsHealth();
      const interval = setInterval(loadEndpointsHealth, 30000); // Refresh every 30 seconds
      return () => clearInterval(interval);
    }
  }, [activeTab]);

  // Load badges when tab is active
  useEffect(() => {
    if (activeTab === 'badges') {
      loadBadges();
    }
  }, [activeTab]);

  // Load traffic report when tab is active
  useEffect(() => {
    if (activeTab === 'traffic') {
      loadTrafficReport();
    }
  }, [activeTab]);

  // Load audit logs when audit-logs tab is active
  useEffect(() => {
    if (activeTab === 'audit-logs') {
      loadAuditLogs();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'feedback') {
      loadFeedback();
    }
  }, [activeTab]);

  // Load notifications when notifications tab is active
  useEffect(() => {
    if (activeTab === 'notifications') {
      loadNotifications();
    }
  }, [activeTab]);

  // Load leaderboard when leaderboard tab is active
  useEffect(() => {
    if (activeTab === 'leaderboard') {
      loadLeaderboard();
    }
  }, [activeTab, leaderboardFilter]);

  useEffect(() => {
    if (activeTab === 'voip') {
      loadVoipLogs();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'ip-monitor') {
      loadIpMonitor();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'coin-management') {
      loadCoinUsers();
    }
  }, [activeTab]);

  // Load custom fonts when fonts tab is active
  useEffect(() => {
    if (activeTab === 'fonts') {
      loadCustomFonts();
    }
  }, [activeTab]);

  // Load Audit Logs
  const loadAuditLogs = async () => {
    setLoadingAuditLogs(true);
    try {
      const res = await axios.get(`${API}/logs/audit`);
      setAuditLogs(res.data);
    } catch (error) {
      console.error('Failed to load audit logs:', error);
      setAuditLogs([]);
      toast.error(error.response?.data?.detail || 'Failed to load audit logs');
    } finally {
      setLoadingAuditLogs(false);
    }
  };

  const loadFeedback = async () => {
    setLoadingFeedback(true);
    try {
      const res = await axios.get(`${API}/feedback`);
      setFeedback(res.data || []);
    } catch (error) {
      setFeedback([]);
      toast.error(error.response?.data?.detail || 'Failed to load feedback');
    } finally {
      setLoadingFeedback(false);
    }
  };

  const updateFeedbackStatus = async (feedbackId, status) => {
    try {
      await axios.put(`${API}/feedback/${feedbackId}/status?status=${status}`);
      toast.success('Feedback status updated');
      loadFeedback();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update feedback status');
    }
  };

  // Load Notifications
  const loadNotifications = async () => {
    setLoadingNotifications(true);
    try {
      const res = await axios.get(`${API}/admin/notifications`);
      setNotifications(res.data);
    } catch (error) {
      console.error('Failed to load notifications:', error);
      setNotifications([]);
    } finally {
      setLoadingNotifications(false);
    }
  };

  // Create Notification/Banner
  const createNotification = async () => {
    try {
      await axios.post(`${API}/admin/notifications`, newNotification);
      toast.success('Notification created successfully');
      setNewNotification({
        title: '',
        message: '',
        target_type: 'all',
        target_id: '',
        duration_hours: 24,
        color: '#3B82F6'
      });
      loadNotifications();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create notification');
    }
  };

  // Delete Notification
  const deleteNotification = async (notificationId) => {
    try {
      await axios.delete(`${API}/admin/notifications/${notificationId}`);
      toast.success('Notification deleted');
      loadNotifications();
    } catch (error) {
      toast.error('Failed to delete notification');
    }
  };

  // Load Leaderboard
  const loadLeaderboard = async () => {
    setLoadingLeaderboard(true);
    try {
      const res = await axios.get(`${API}/admin/leaderboard?sort_by=${leaderboardFilter}`);
      setLeaderboard(res.data);
    } catch (error) {
      console.error('Failed to load leaderboard:', error);
      const safe = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
      };
      const fieldMap = {
        coins: 'coins',
        logins: 'login_count',
        friends: 'friend_count',
        rooms: 'room_created_count',
      };
      const field = fieldMap[leaderboardFilter] || 'coins';
      const fallback = (allUsers || []).map((u) => ({
        id: u.id,
        user_id: u.id,
        username: u.username || u.display_name || 'unknown',
        role: u.role,
        coins: safe(u.coins),
        login_count: safe(u.login_count),
        friend_count: safe(u.friend_count),
        room_created_count: safe(u.room_created_count),
      })).sort((a, b) => safe(b[field]) - safe(a[field]));
      setLeaderboard(fallback);
    } finally {
      setLoadingLeaderboard(false);
    }
  };

  const loadIpMonitor = async () => {
    try {
      const res = await axios.get(`${API}/admin/ip-monitor`);
      setIpMonitor(res.data || { summary: {}, multi_ip_users: [], shared_ip_groups: [], recent_logs: [] });
    } catch (error) {
      console.error('Failed to load IP monitor:', error);
      toast.error('Failed to load IP monitor data');
    }
  };

  const loadVoipLogs = async () => {
    try {
      const res = await axios.get(`${API}/admin/voip/logs`);
      setVoipLogs(res.data || []);
    } catch (error) {
      setVoipLogs([]);
    }
  };

  const loadCoinUsers = async () => {
    try {
      const res = await axios.get(`${API}/admin/coins/users`);
      setCoinUsers(res.data || []);
    } catch (error) {
      setCoinUsers([]);
    }
  };

  const giftCoins = async () => {
    try {
      await axios.post(`${API}/admin/coins/gift`, coinAction);
      toast.success('Coins gifted');
      loadCoinUsers();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to gift coins');
    }
  };

  const cutCoins = async () => {
    try {
      await axios.post(`${API}/admin/coins/cut`, coinAction);
      toast.success('Coins deducted');
      loadCoinUsers();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to cut coins');
    }
  };

  // Load Custom Fonts
  const loadCustomFonts = async () => {
    try {
      const res = await axios.get(`${API}/admin/fonts`);
      setCustomFonts(res.data);
    } catch (error) {
      console.error('Failed to load fonts:', error);
      setCustomFonts([]);
    }
  };

  // Upload Custom Font
  const uploadFont = async (file) => {
    setUploadingFont(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      await axios.post(`${API}/admin/fonts/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Font uploaded successfully');
      loadCustomFonts();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to upload font');
    } finally {
      setUploadingFont(false);
    }
  };

  // Delete Custom Font
  const deleteFont = async (fontId) => {
    if (!window.confirm('Are you sure you want to delete this font?')) return;
    try {
      await axios.delete(`${API}/admin/fonts/${fontId}`);
      toast.success('Font deleted');
      loadCustomFonts();
    } catch (error) {
      toast.error('Failed to delete font');
    }
  };

  // Load Ad Scripts
  const loadAdScripts = async () => {
    try {
      const res = await axios.get(`${API}/admin/ad-scripts`);
      setAdScripts(res.data);
    } catch (error) {
      console.error('Failed to load ad scripts:', error);
      setAdScripts([]);
    }
  };

  // Save Ad Script
  const saveAdScript = async () => {
    try {
      await axios.post(`${API}/admin/ad-scripts`, newAdScript);
      toast.success('Ad script saved successfully');
      setNewAdScript({
        script_code: '',
        target_page: 'landing',
        position: 'footer',
        is_active: true
      });
      loadAdScripts();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to save ad script');
    }
  };

  // Delete Ad Script
  const deleteAdScript = async (scriptId) => {
    if (!window.confirm('Are you sure you want to delete this ad script?')) return;
    try {
      await axios.delete(`${API}/admin/ad-scripts/${scriptId}`);
      toast.success('Ad script deleted');
      loadAdScripts();
    } catch (error) {
      toast.error('Failed to delete ad script');
    }
  };

  // Toggle Ad Script Active State
  const toggleAdScript = async (scriptId, isActive) => {
    try {
      await axios.patch(`${API}/admin/ad-scripts/${scriptId}`, { is_active: isActive });
      toast.success(`Ad script ${isActive ? 'activated' : 'deactivated'}`);
      loadAdScripts();
    } catch (error) {
      toast.error('Failed to update ad script');
    }
  };

  const createStaff = async () => {
    try {
      await axios.post(`${API}/staff`, newStaff);
      toast.success('Staff created successfully');
      setCreateStaffOpen(false);
      setNewStaff({ username: '', email: '', password: '' });
      loadData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create staff');
    }
  };

  const deleteStaff = async (staffId) => {
    if (!window.confirm('Are you sure you want to delete this staff member?')) return;
    try {
      await axios.delete(`${API}/staff/${staffId}`);
      toast.success('Staff deleted');
      loadData();
    } catch (error) {
      toast.error('Failed to delete staff');
    }
  };

  const createGame = async () => {
    try {
      await axios.post(`${API}/games`, newGame);
      toast.success('Game added successfully');
      setCreateGameOpen(false);
      setNewGame({ name: '', url: '', description: '' });
      loadData();
    } catch (error) {
      toast.error('Failed to add game');
    }
  };

  const deleteGame = async (gameId) => {
    if (!window.confirm('Are you sure you want to delete this game?')) return;
    try {
      await axios.delete(`${API}/games/${gameId}`);
      toast.success('Game deleted');
      loadData();
    } catch (error) {
      toast.error('Failed to delete game');
    }
  };

  const saveAdBanner = async () => {
    if (!adUrl.trim()) {
      toast.error('Please enter a valid ad URL');
      return;
    }
    try {
      await axios.post(`${API}/ads`, { ad_url: adUrl });
      toast.success('Ad banner updated successfully');
      loadData();
    } catch (error) {
      toast.error('Failed to update ad banner');
    }
  };

  const deleteAd = async () => {
    if (!currentAd) return;
    if (!window.confirm('Are you sure you want to delete the ad banner?')) return;
    try {
      await axios.delete(`${API}/ads/${currentAd.id}`);
      toast.success('Ad banner deleted');
      setCurrentAd(null);
      setAdUrl('');
      loadData();
    } catch (error) {
      toast.error('Failed to delete ad banner');
    }
  };
  // Footer management functions
  const loadFooterContent = async () => {
    try {
      const response = await axios.get(`${API}/footer/content`);
      if (response.data.links) {
        setFooterLinks(response.data.links);
      }
      if (response.data.copyright_text) {
        setCopyrightText(response.data.copyright_text);
      }
    } catch (error) {
      console.error('Failed to load footer content:', error);
    }
  };

  const saveFooterContent = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/admin/footer/content`, {
        links: footerLinks,
        copyright_text: copyrightText || `© ${new Date().getFullYear()} ChatHub. All rights reserved.`
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Footer content updated successfully');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update footer content');
    }
  };

  const resetFooterContent = async () => {
    if (!window.confirm('Are you sure you want to reset footer to default?')) return;
    
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/admin/footer/content`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFooterLinks([
        { label: 'Premium', url: '/premium' },
        { label: 'Contact', url: '/feedback' },
        { label: 'Sign In', url: '/auth' }
      ]);
      setCopyrightText('');
      toast.success('Footer reset to default');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to reset footer');
    }
  };

  const addFooterLink = () => {
    setFooterLinks([...footerLinks, { label: '', url: '' }]);
  };

  const updateFooterLink = (index, field, value) => {
    const updated = [...footerLinks];
    updated[index][field] = value;
    setFooterLinks(updated);
  };

  const removeFooterLink = (index) => {
    setFooterLinks(footerLinks.filter((_, i) => i !== index));
  };

  // Avatar Management
  const uploadAvatar = async (gender, file) => {
    if (!file) return;
    setUploadingAvatar(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('gender', gender);
      
      const response = await axios.post(`${API}/admin/avatars`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      const newAvatar = response.data;
      if (gender === 'male') {
        setMaleAvatars(prev => [...prev, newAvatar]);
      } else {
        setFemaleAvatars(prev => [...prev, newAvatar]);
      }
      toast.success(`${gender.charAt(0).toUpperCase() + gender.slice(1)} avatar uploaded successfully`);
    } catch (error) {
      toast.error('Failed to upload avatar');
    } finally {
      setUploadingAvatar(false);
    }
  };

  const deleteAvatar = async (avatarId) => {
    if (!window.confirm('Delete this avatar?')) return;
    try {
      await axios.delete(`${API}/admin/avatars/${avatarId}`);
      toast.success('Avatar deleted');
      loadData();
    } catch (error) {
      toast.error('Failed to delete avatar');
    }
  };

  // Index Page Content
  const updateIndexContent = async (section) => {
    try {
      await axios.put(`${API}/admin/index-content`, null, {
        params: { section, content: editContent }
      });
      toast.success('Content updated successfully');
      setEditingSection('');
      setEditContent('');
      loadData();
    } catch (error) {
      toast.error('Failed to update content');
    }
  };

  // Premium User Management
  const searchUsers = async () => {
    if (!userSearchQuery.trim()) {
      toast.error('Please enter a search query');
      return;
    }
    try {
      const response = await axios.get(`${API}/admin/users/search`, {
        params: { q: userSearchQuery, query: userSearchQuery }
      });
      setSearchResults(response.data);
    } catch (error) {
      const q = userSearchQuery.trim().toLowerCase();
      const fallback = (allUsers || []).filter((u) =>
        (u.username || '').toLowerCase().includes(q) ||
        (u.display_name || '').toLowerCase().includes(q) ||
        (u.email || '').toLowerCase().includes(q) ||
        (u.id || '').toLowerCase().includes(q)
      );
      setSearchResults(fallback);
      toast.error(error.response?.data?.detail || 'Failed to search users');
    }
  };

  const searchUsersForPasswordReset = async () => {
    const q = passwordSearchQuery.trim();
    if (!q) {
      toast.error('Please enter username, display name, or user ID');
      return;
    }

    try {
      const response = await axios.get(`${API}/admin/users/search`, {
        params: { q, query: q }
      });
      setPasswordSearchResults(response.data || []);
    } catch (error) {
      const fallback = (allUsers || []).filter((u) =>
        (u.username || '').toLowerCase().includes(q.toLowerCase()) ||
        (u.display_name || '').toLowerCase().includes(q.toLowerCase()) ||
        (u.id || '').toLowerCase().includes(q.toLowerCase())
      );
      setPasswordSearchResults(fallback);
      toast.error(error.response?.data?.detail || 'Failed to search users');
    }
  };

  const resetUserPasswordFromAdmin = async () => {
    if (!selectedPasswordUser?.id) {
      toast.error('Please select a user first');
      return;
    }

    const newPassword = adminResetPassword.newPassword || '';
    const confirmPassword = adminResetPassword.confirmPassword || '';

    if (newPassword.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (!window.confirm(`Reset password for ${selectedPasswordUser.username || selectedPasswordUser.id}?`)) {
      return;
    }

    try {
      setResettingPassword(true);
      await axios.post(`${API}/admin/users/${selectedPasswordUser.id}/reset-password`, {
        new_password: newPassword
      });
      toast.success('Password reset successfully');
      setAdminResetPassword({ newPassword: '', confirmPassword: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to reset password');
    } finally {
      setResettingPassword(false);
    }
  };

  const togglePremium = async (userId, currentRole) => {
    const makePremium = currentRole !== 'premium';
    const action = makePremium ? 'upgrade to' : 'downgrade from';
    
    if (!window.confirm(`Are you sure you want to ${action} premium?`)) return;
    
    try {
      await axios.post(`${API}/admin/premium/toggle`, {
        user_id: userId,
        make_premium: makePremium
      });
      toast.success(`User ${action} premium successfully`);
      searchUsers(); // Refresh search results
      loadPremiumUsers(); // Refresh premium users list
    } catch (error) {
      toast.error(`Failed to ${action} premium`);
    }
  };

  // Room management functions
  const deleteRoom = async (roomId) => {
    if (!window.confirm('Are you sure you want to delete this room? This cannot be undone.')) return;
    
    try {
      await axios.delete(`${API}/rooms/${roomId}`);
      toast.success('Room deleted successfully');
      loadData(); // Refresh rooms list
    } catch (error) {
      toast.error('Failed to delete room');
    }
  };

  // User management functions
  const deleteUser = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user? This cannot be undone.')) return;
    
    try {
      await axios.delete(`${API}/admin/users/${userId}`);
      toast.success('User deleted successfully');
      loadData(); // Refresh users list
    } catch (error) {
      toast.error('Failed to delete user');
    }
  };

  const banUser = async (userId) => {
    if (!window.confirm('Are you sure you want to ban this user?')) return;
    
    try {
      await axios.post(`${API}/admin/users/${userId}/ban`);
      toast.success('User banned successfully');
      loadData(); // Refresh users list
    } catch (error) {
      toast.error('Failed to ban user');
    }
  };

  const unbanUser = async (userId) => {
    if (!window.confirm('Are you sure you want to unban this user?')) return;
    
    try {
      await axios.post(`${API}/admin/users/${userId}/unban`);
      toast.success('User unbanned successfully');
      loadData(); // Refresh users list
    } catch (error) {
      toast.error('Failed to unban user');
    }
  };

  // Theme management functions
  const updateGlobalTheme = async () => {
    try {
      await axios.put(`${API}/admin/theme/global`, globalTheme);
      toast.success('Global theme updated successfully');
    } catch (error) {
      toast.error('Failed to update theme');
    }
  };

  // Chat Logs Search
  const searchChatLogs = async () => {
    if (!logSearchUserId.trim()) {
      toast.error('Please enter a user ID');
      return;
    }
    try {
      const response = await axios.post(`${API}/admin/chat-logs/search`, {
        user_id: logSearchUserId,
        log_type: 'all'
      });
      setChatLogs(response.data);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to search chat logs');
    }
  };

  const cleanupMedia = async () => {
    if (!window.confirm('This will delete media files older than 30 days. Continue?')) return;
    try {
      const response = await axios.post(`${API}/maintenance/cleanup-media`);
      toast.success(response.data.message);
    } catch (error) {
      toast.error('Failed to cleanup media');
    }
  };

  // Bulk delete users
  const bulkDeleteUsers = async () => {
    if (selectedUsers.length === 0) {
      toast.error('Please select users to delete');
      return;
    }
    
    if (!window.confirm(`Are you sure you want to delete ${selectedUsers.length} user(s)? This cannot be undone.`)) return;
    
    try {
      await Promise.all(selectedUsers.map(userId => axios.delete(`${API}/admin/users/${userId}`)));
      toast.success(`Successfully deleted ${selectedUsers.length} user(s)`);
      setSelectedUsers([]);
      loadData();
    } catch (error) {
      toast.error('Failed to delete some users');
    }
  };

  const toggleUserSelection = (userId) => {
    setSelectedUsers(prev => 
      prev.includes(userId) 
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const toggleAllUsers = () => {
    if (selectedUsers.length === allUsers.filter(u => u.role !== 'super_admin').length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(allUsers.filter(u => u.role !== 'super_admin').map(u => u.id));
    }
  };

  // Load premium users specifically
  const loadPremiumUsers = async () => {
    try {
      const response = await axios.get(`${API}/admin/users/premium`);
      setPremiumUsers(response.data || []);
      console.log('Premium users loaded:', response.data);
    } catch (error) {
      console.error('Failed to load premium users:', error);
      const fallback = (allUsers || []).filter((u) => String(u.role || '').toLowerCase() === 'premium');
      setPremiumUsers(fallback);
      toast.error(error.response?.data?.detail || 'Failed to load premium users');
    }
  };

  // Load premium requests
  const loadPremiumRequests = async () => {
    try {
      const response = await axios.get(`${API}/admin/premium/requests`);
      setPremiumRequests(response.data || []);
    } catch (error) {
      console.error('Failed to load premium requests:', error);
      toast.error('Failed to load premium requests');
    }
  };

  // Approve premium request
  const approvePremiumRequest = async (requestId) => {
    if (!window.confirm('Approve this premium access request?')) return;
    
    try {
      await axios.post(`${API}/admin/premium/requests/${requestId}/approve`);
      toast.success('Premium request approved successfully');
      loadPremiumRequests();
      loadPremiumUsers();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to approve request');
    }
  };

  // Reject premium request
  const rejectPremiumRequest = async (requestId) => {
    if (!window.confirm('Reject this premium access request?')) return;
    
    try {
      await axios.post(`${API}/admin/premium/requests/${requestId}/reject`);
      toast.success('Premium request rejected');
      loadPremiumRequests();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to reject request');
    }
  };

  // Premium user removal
  const removePremiumStatus = async (userId) => {
    if (!window.confirm('Are you sure you want to remove premium status from this user?')) return;
    
    try {
      await axios.put(`${API}/admin/users/${userId}/premium`);
      toast.success('Premium status removed successfully');
      loadPremiumUsers(); // Refresh only premium users list
      loadData(); // Refresh all data
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to remove premium status');
    }
  };

  // PM Logs enhancement - Load ALL users instead of just users with PMs
  const loadPmUsers = async () => {
    try {
      const response = await axios.get(`${API}/admin/users`);
      setPmUsersList(response.data);
    } catch (error) {
      toast.error('Failed to load users');
    }
  };

  const loadPmFriends = async (userId) => {
    try {
      setSelectedPmUser(userId);
      const response = await axios.get(`${API}/admin/pm-logs/users/${userId}/friends`);
      setPmFriendsList(response.data);
      setSelectedPmFriend(null);
      setPmConversation([]);
    } catch (error) {
      toast.error('Failed to load user friends');
    }
  };

  const loadPmConversation = async (userId, friendId) => {
    try {
      setSelectedPmFriend(friendId);
      const response = await axios.get(`${API}/admin/pm-logs/conversation/${userId}/${friendId}`);
      setPmConversation(response.data);
    } catch (error) {
      toast.error('Failed to load PM conversation');
    }
  };

  // Database collection viewer
  const viewCollection = async (collectionName) => {
    try {
      setSelectedCollection(collectionName);
      const response = await axios.get(`${API}/admin/db/${collectionName}`);
      setCollectionData(response.data);
      toast.success(`Loaded ${response.data.count} records from ${collectionName}`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to load collection data');
      setSelectedCollection(null);
      setCollectionData(null);
    }
  };

  const closeCollectionViewer = () => {
    setSelectedCollection(null);
    setCollectionData(null);
  };

  // Staff permissions functions
  const openPermissionsDialog = async (staffMember) => {
    setSelectedStaff(staffMember);
    try {
      const response = await axios.get(`${API}/staff/${staffMember.id}/permissions`);
      setStaffPermissions(response.data);
      setPermissionsDialogOpen(true);
    } catch (error) {
      toast.error('Failed to load permissions');
    }
  };

  const updateStaffPermissions = async () => {
    try {
      await axios.put(`${API}/staff/${selectedStaff.id}/permissions`, staffPermissions);
      toast.success('Permissions updated successfully');
      setPermissionsDialogOpen(false);
    } catch (error) {
      toast.error('Failed to update permissions');
    }
  };

  // Email verification request functions
  const loadVerificationRequests = async () => {
    try {
      const response = await axios.get(`${API}/admin/verification-requests`);
      setVerificationRequests(response.data || []);
    } catch (error) {
      toast.error('Failed to load verification requests');
    }
  };

  const grantVerification = async (requestId, username) => {
    if (!window.confirm(`Are you sure you want to grant access to ${username}?`)) return;
    try {
      await axios.post(`${API}/admin/verification-requests/${requestId}/grant`);
      toast.success(`Access granted to ${username}`);
      loadVerificationRequests();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to grant access');
    }
  };

  const denyVerification = async (requestId, username) => {
    const reason = window.prompt(`Why are you denying verification for ${username}?`);
    if (reason === null) return; // User cancelled
    try {
      await axios.post(`${API}/admin/verification-requests/${requestId}/deny`, { reason });
      toast.success(`Request denied for ${username}`);
      loadVerificationRequests();
    } catch (error) {
      toast.error('Failed to deny request');
    }
  };

  // File Editor functions
  const loadIndexHtml = async () => {
    try {
      const response = await axios.get(`${API}/admin/files/index-html`);
      setIndexHtmlContent(response.data.content);
      setIndexHtmlPath(response.data.path);
    } catch (error) {
      toast.error('Failed to load index.html');
    }
  };

  const saveIndexHtml = async () => {
    if (!window.confirm('Are you sure you want to save changes to index.html?')) return;
    setSavingFile(true);
    try {
      await axios.post(`${API}/admin/files/index-html`, { content: indexHtmlContent });
      toast.success('index.html saved successfully! Backup created.');
    } catch (error) {
      toast.error('Failed to save index.html');
    } finally {
      setSavingFile(false);
    }
  };

  // Apply Updates function - triggers cache clear and service restart
  const applyUpdates = async (updateType) => {
    const confirmMsg = updateType === 'index_html' 
      ? 'This will sync changes to all index.html files. Continue?'
      : updateType === 'ad_scripts'
      ? 'This will update ad scripts version. Clients will auto-refresh within 30 seconds. Continue?'
      : 'This will sync all changes. Continue?';
    
    if (!window.confirm(confirmMsg)) return;
    
    setApplyingUpdates(true);
    try {
      const response = await axios.post(`${API}/admin/apply-updates?update_type=${updateType}`);
      
      if (response.data.success) {
        toast.success(response.data.message || 'Updates applied successfully!', {
          duration: 4000
        });
        
        // Show details of what was done
        const actions = response.data.actions || [];
        actions.forEach(action => {
          if (action.message && !action.message.includes('success')) {
            toast.info(action.message, { duration: 3000 });
          }
        });
        
        // Reload ad scripts if that was the update type
        if (updateType === 'ad_scripts' || updateType === 'all') {
          loadAdScripts();
        }
      } else {
        toast.warning(response.data.message || 'Some updates may have failed.', { duration: 5000 });
      }
    } catch (error) {
      toast.error('Failed to apply updates: ' + (error.response?.data?.detail || error.message));
    } finally {
      setApplyingUpdates(false);
    }
  };

  // Meta Tags functions
  const loadMetaTags = async () => {
    try {
      const response = await axios.get(`${API}/admin/meta-tags`);
      setMetaTagsContent(response.data.content || '');
      setMetaTagsLastUpdated(response.data.last_updated);
    } catch (error) {
      toast.error('Failed to load meta tags');
    }
  };

  const saveMetaTags = async () => {
    if (!window.confirm('Are you sure you want to save these meta tags to index.html?')) return;
    setSavingMetaTags(true);
    try {
      await axios.post(`${API}/admin/meta-tags`, { content: metaTagsContent });
      toast.success('Meta tags saved successfully! Click "Update Settings" to apply changes.');
      loadMetaTags(); // Reload to get updated timestamp
    } catch (error) {
      toast.error('Failed to save meta tags: ' + (error.response?.data?.detail || error.message));
    } finally {
      setSavingMetaTags(false);
    }
  };

  // Database Editor functions
  const loadDbCollections = async () => {
    try {
      const response = await axios.get(`${API}/admin/database/collections`);
      setDbCollections(response.data);
    } catch (error) {
      toast.error('Failed to load collections');
    }
  };

  const loadDbCollectionData = async (collectionName) => {
    try {
      const response = await axios.get(`${API}/admin/database/collections/${collectionName}`);
      setSelectedDbCollection(collectionName);
      setDbCollectionData(response.data.documents);
      setDbCollectionTotal(response.data.total);
    } catch (error) {
      toast.error('Failed to load collection data');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Tab navigation items - Optimized for Railway/Vercel/Atlas deployment
  const tabItems = [
    { id: 'staff', label: 'Staff', icon: Users },
    { id: 'rooms', label: 'Rooms', icon: MessageSquare },
    { id: 'users', label: 'Users', icon: User },
    { id: 'passwords', label: 'Passwords', icon: EyeOff },
    { id: 'feedback', label: 'Feedback', icon: MailCheck },
    { id: 'audit-logs', label: 'Audit Logs', icon: Shield },
    { id: 'notifications', label: 'Notifications', icon: AlertTriangle },
    { id: 'leaderboard', label: 'Leaderboard', icon: Crown },
    { id: 'coin-management', label: 'Coin Management', icon: Coins },
    { id: 'voip', label: 'VoIP', icon: Phone },
    { id: 'ip-monitor', label: 'IP Monitor', icon: Shield },
    { id: 'endpoints-health', label: 'Endpoints Health', icon: Activity },
    { id: 'system-health', label: 'System Health', icon: Activity },
    { id: 'badges', label: 'Badge Manager', icon: Shield },
    { id: 'traffic', label: 'Web Traffic', icon: Activity },
    { id: 'themes', label: 'Themes', icon: Edit },
    { id: 'fonts', label: 'Fonts', icon: Edit },
    { id: 'games', label: 'Games', icon: GamepadIcon },
    { id: 'avatars', label: 'Avatars', icon: ImageIcon },
    { id: 'premium', label: 'Premium', icon: Crown },
    { id: 'chatlogs', label: 'Chat Logs', icon: MessageSquare },
    { id: 'pmlogs', label: 'PM Logs', icon: MessageSquare },
    { id: 'verification', label: 'Email Verification', icon: MailCheck },
    { id: 'otp-monitoring', label: 'OTP & Resend Status', icon: Activity },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="flex flex-col md:flex-row">
        {/* Side Panel Navigation - Hidden on mobile, drawer on tablet, sidebar on desktop */}
        <div className="w-full md:w-64 bg-white shadow-lg md:min-h-screen">
          {/* Header */}
          <div className="p-4 sm:p-6 border-b">
            <h2 className="text-lg sm:text-xl font-bold text-gray-800">Admin Panel</h2>
            <p className="text-xs sm:text-sm text-gray-600">System Control</p>
          </div>
          
          {/* Navigation Items */}
          <nav className="p-2 sm:p-4">
            <div className="space-y-1 max-h-[60vh] md:max-h-none overflow-y-auto">
              {tabItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => setActiveTab(item.id)}
                    className={`w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-4 py-2 sm:py-3 rounded-lg transition-colors text-sm sm:text-base ${
                      activeTab === item.id
                        ? 'bg-blue-600 text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                    data-testid={`nav-${item.id}`}
                  >
                    <Icon className="w-5 h-5" />
                    <span className="font-medium">{item.label}</span>
                  </button>
                );
              })}
            </div>
            
            {/* Back Button */}
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="w-full mt-6"
              data-testid="back-button"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>

            {/* System Monitor Button */}
            <Button
              onClick={() => navigate('/system-monitor')}
              className="w-full mt-2 bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700"
              data-testid="system-monitor-button"
            >
              <Activity className="w-4 h-4 mr-2" />
              System Monitor
            </Button>
          </nav>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 p-2 sm:p-4 md:p-6">
          <div className="max-w-6xl mx-auto">
            {/* Content based on active tab */}
            {activeTab === 'staff' && (
            <div>
            <Card>
              <CardHeader>
                <div className="flex justify-between items-center">
                  <CardTitle>Staff Management</CardTitle>
                  <Dialog open={createStaffOpen} onOpenChange={setCreateStaffOpen}>
                    <DialogTrigger asChild>
                      <Button data-testid="create-staff-button">
                        <UserPlus className="w-4 h-4 mr-2" />
                        Create Staff
                      </Button>
                    </DialogTrigger>
                    <DialogContent>
                      <DialogHeader>
                        <DialogTitle>Create New Staff</DialogTitle>
                      </DialogHeader>
                      <div className="space-y-4">
                        <div>
                          <Label>Username</Label>
                          <Input
                            value={newStaff.username}
                            onChange={(e) => setNewStaff({ ...newStaff, username: e.target.value })}
                            data-testid="staff-username-input"
                          />
                        </div>
                        <div>
                          <Label>Email</Label>
                          <Input
                            type="email"
                            value={newStaff.email}
                            onChange={(e) => setNewStaff({ ...newStaff, email: e.target.value })}
                            data-testid="staff-email-input"
                          />
                        </div>
                        <div>
                          <Label>Password</Label>
                          <PasswordInput
                            value={newStaff.password}
                            onChange={(e) => setNewStaff({ ...newStaff, password: e.target.value })}
                            data-testid="staff-password-input"
                          />
                        </div>
                        <Button onClick={createStaff} className="w-full" data-testid="submit-staff-button">
                          Create Staff
                        </Button>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {staff.map((s) => (
                    <div key={s.id} className="flex items-center justify-between p-3 border rounded-lg bg-white" data-testid={`staff-${s.id}`}>
                      <div>
                        <p className="font-semibold">{s.username}</p>
                        <p className="text-sm text-gray-500">{s.email}</p>
                      </div>
                      <div className="flex gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => openPermissionsDialog(s)}
                        >
                          <User className="w-4 h-4 mr-1" />
                          Permissions
                        </Button>
                        <Button
                          variant="destructive"
                          size="sm"
                          onClick={() => deleteStaff(s.id)}
                          data-testid={`delete-staff-${s.id}`}
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                  ))}
                  {staff.length === 0 && (
                    <p className="text-center text-gray-500 py-8">No staff members yet</p>
                  )}
                </div>
              </CardContent>
            </Card>

            {/* Staff Permissions Dialog */}
            <Dialog open={permissionsDialogOpen} onOpenChange={setPermissionsDialogOpen}>
              <DialogContent className="max-w-md">
                <DialogHeader>
                  <DialogTitle>Staff Permissions: {selectedStaff?.username}</DialogTitle>
                  <p className="text-sm text-gray-600">Configure what this staff member can do</p>
                </DialogHeader>
                <div className="space-y-4 py-4">
                  <div className="flex items-center justify-between">
                    <Label htmlFor="can_create_users" className="flex-1">Create/Remove Users</Label>
                    <input
                      id="can_create_users"
                      type="checkbox"
                      checked={staffPermissions.can_create_users}
                      onChange={(e) => setStaffPermissions({...staffPermissions, can_create_users: e.target.checked})}
                      className="w-5 h-5"
                    />
                  </div>
                  <div className="flex items-center justify-between">
                    <Label htmlFor="can_ban_users" className="flex-1">Ban/Unban Users</Label>
                    <input
                      id="can_ban_users"
                      type="checkbox"
                      checked={staffPermissions.can_ban_users}
                      onChange={(e) => setStaffPermissions({...staffPermissions, can_ban_users: e.target.checked})}
                      className="w-5 h-5"
                    />
                  </div>
                  <div className="flex items-center justify-between">
                    <Label htmlFor="can_view_chat_logs" className="flex-1">View Chat Logs</Label>
                    <input
                      id="can_view_chat_logs"
                      type="checkbox"
                      checked={staffPermissions.can_view_chat_logs}
                      onChange={(e) => setStaffPermissions({...staffPermissions, can_view_chat_logs: e.target.checked})}
                      className="w-5 h-5"
                    />
                  </div>
                  <div className="flex items-center justify-between">
                    <Label htmlFor="can_view_room_logs" className="flex-1">View Room Logs</Label>
                    <input
                      id="can_view_room_logs"
                      type="checkbox"
                      checked={staffPermissions.can_view_room_logs}
                      onChange={(e) => setStaffPermissions({...staffPermissions, can_view_room_logs: e.target.checked})}
                      className="w-5 h-5"
                    />
                  </div>
                  <div className="flex items-center justify-between">
                    <Label htmlFor="can_manage_rooms" className="flex-1">Create/Remove Rooms</Label>
                    <input
                      id="can_manage_rooms"
                      type="checkbox"
                      checked={staffPermissions.can_manage_rooms}
                      onChange={(e) => setStaffPermissions({...staffPermissions, can_manage_rooms: e.target.checked})}
                      className="w-5 h-5"
                    />
                  </div>
                  <div className="flex items-center justify-between">
                    <Label htmlFor="can_grant_email_verification" className="flex-1">Grant Email Verification Access</Label>
                    <input
                      id="can_grant_email_verification"
                      type="checkbox"
                      checked={staffPermissions.can_grant_email_verification}
                      onChange={(e) => setStaffPermissions({...staffPermissions, can_grant_email_verification: e.target.checked})}
                      className="w-5 h-5"
                    />
                  </div>
                </div>
                <Button onClick={updateStaffPermissions} className="w-full">
                  Save Permissions
                </Button>
              </DialogContent>
            </Dialog>
            </div>
            )}

            {/* Rooms Tab */}
            {activeTab === 'rooms' && (
            <div>
            <Card>
              <CardHeader>
                <CardTitle>Rooms Management ({rooms.length})</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {rooms.map((room) => (
                    <div key={room.id} className="flex items-center justify-between p-3 border rounded-lg bg-white">
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <p className="font-semibold">{room.name}</p>
                          <Badge variant={room.type === 'public' ? 'default' : 'secondary'}>
                            {room.type}
                          </Badge>
                        </div>
                        <p className="text-sm text-gray-500">{room.description || 'No description'}</p>
                        <p className="text-xs text-gray-400 mt-1">
                          Created: {new Date(room.created_at).toLocaleDateString()}
                        </p>
                      </div>
                      <div className="flex gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => navigate(`/room-logs/${room.id}`)}
                        >
                          <MessageSquare className="w-4 h-4 mr-1" />
                          View Logs
                        </Button>
                        <Button
                          variant="destructive"
                          size="sm"
                          onClick={() => deleteRoom(room.id)}
                        >
                          <Trash2 className="w-4 h-4 mr-1" />
                          Remove
                        </Button>
                      </div>
                    </div>
                  ))}
                  {rooms.length === 0 && (
                    <p className="text-center text-gray-500 py-8">No rooms found</p>
                  )}
                </div>
              </CardContent>
            </Card>
            </div>
            )}

            {/* Users Tab */}
            {activeTab === 'users' && (
            <div>
            <Card>
              <CardHeader>
                <div className="flex justify-between items-center">
                  <CardTitle>Users Management ({allUsers.length})</CardTitle>
                  {selectedUsers.length > 0 && (
                    <Button
                      variant="destructive"
                      onClick={bulkDeleteUsers}
                    >
                      <Trash2 className="w-4 h-4 mr-2" />
                      Delete Selected ({selectedUsers.length})
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardContent>
                <div className="mb-4 flex gap-2">
                  <Input
                    placeholder="Search users by username..."
                    value={userSearchQuery}
                    onChange={(e) => setUserSearchQuery(e.target.value)}
                    className="flex-1"
                  />
                  <Button
                    variant="outline"
                    onClick={toggleAllUsers}
                    size="sm"
                  >
                    {selectedUsers.length === allUsers.filter(u => u.role !== 'super_admin').length ? 'Deselect All' : 'Select All'}
                  </Button>
                </div>
                <ScrollArea className="h-[500px]">
                  <div className="space-y-3">
                    {allUsers
                      .filter(u => !userSearchQuery || u.username?.toLowerCase().includes(userSearchQuery.toLowerCase()))
                      .map((user) => (
                      <div key={user.id} className="flex items-center gap-3 p-3 border rounded-lg bg-white">
                        {user.role !== 'super_admin' && (
                          <input
                            type="checkbox"
                            checked={selectedUsers.includes(user.id)}
                            onChange={() => toggleUserSelection(user.id)}
                            className="w-4 h-4 cursor-pointer"
                          />
                        )}
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <p className="font-semibold">{user.username}</p>
                            <Badge variant={
                              user.role === 'super_admin' ? 'destructive' :
                              user.role === 'staff' ? 'default' :
                              user.role === 'premium' ? 'secondary' :
                              'outline'
                            }>
                              {user.role}
                            </Badge>
                            {user.is_banned && <Badge variant="destructive">Banned</Badge>}
                          </div>
                          <p className="text-sm text-gray-500">{user.email}</p>
                          <p className="text-xs text-gray-400 mt-1">
                            Joined: {new Date(user.created_at).toLocaleDateString()}
                          </p>
                        </div>
                        <div className="flex gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => navigate(`/profile/${user.id}`)}
                          >
                            <User className="w-4 h-4 mr-1" />
                            View Profile
                          </Button>
                          {user.is_banned ? (
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => unbanUser(user.id)}
                            >
                              Unban
                            </Button>
                          ) : user.role !== 'super_admin' && (
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => banUser(user.id)}
                            >
                              Ban
                            </Button>
                          )}
                          {user.role !== 'super_admin' && (
                            <Button
                              variant="destructive"
                              size="sm"
                              onClick={() => deleteUser(user.id)}
                            >
                              <Trash2 className="w-4 h-4 mr-1" />
                              Remove
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}
                    {allUsers.length === 0 && (
                      <p className="text-center text-gray-500 py-8">No users found</p>
                    )}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>
            </div>
            )}

            {/* Passwords Tab */}
            {activeTab === 'passwords' && (
            <div>
            <Card>
              <CardHeader>
                <CardTitle>Password Reset (Super Admin)</CardTitle>
                <p className="text-sm text-gray-600">Search users by username, display name, or user ID, then reset their password.</p>
              </CardHeader>
              <CardContent>
                <div className="flex flex-col sm:flex-row gap-2 mb-4">
                  <Input
                    placeholder="Search by username / display name / user ID"
                    value={passwordSearchQuery}
                    onChange={(e) => setPasswordSearchQuery(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && searchUsersForPasswordReset()}
                    className="flex-1"
                  />
                  <Button onClick={searchUsersForPasswordReset}>
                    <Search className="w-4 h-4 mr-2" />
                    Search
                  </Button>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <Card>
                    <CardHeader>
                      <CardTitle className="text-base">Matching Users ({passwordSearchResults.length})</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <ScrollArea className="h-[360px]">
                        <div className="space-y-2">
                          {passwordSearchResults.map((u) => (
                            <button
                              key={u.id}
                              onClick={() => setSelectedPasswordUser(u)}
                              className={`w-full text-left p-3 border rounded-lg transition-colors ${
                                selectedPasswordUser?.id === u.id ? 'border-blue-600 bg-blue-50' : 'hover:bg-gray-50'
                              }`}
                            >
                              <p className="font-semibold">{u.username || 'Unknown'}</p>
                              <p className="text-sm text-gray-600">{u.display_name || 'No display name'}</p>
                              <p className="text-xs text-gray-500 break-all">ID: {u.id}</p>
                            </button>
                          ))}
                          {passwordSearchResults.length === 0 && (
                            <p className="text-sm text-gray-500 py-8 text-center">No users found. Run a search.</p>
                          )}
                        </div>
                      </ScrollArea>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="text-base">Reset Password</CardTitle>
                    </CardHeader>
                    <CardContent>
                      {selectedPasswordUser ? (
                        <div className="space-y-4">
                          <div className="p-3 rounded-lg bg-gray-50 border">
                            <p className="font-semibold">{selectedPasswordUser.username || 'Unknown'}</p>
                            <p className="text-sm text-gray-600">{selectedPasswordUser.display_name || 'No display name'}</p>
                            <p className="text-xs text-gray-500 break-all">User ID: {selectedPasswordUser.id}</p>
                          </div>
                          <div className="space-y-2">
                            <Label>New Password</Label>
                            <PasswordInput
                              value={adminResetPassword.newPassword}
                              onChange={(e) => setAdminResetPassword(prev => ({ ...prev, newPassword: e.target.value }))}
                              placeholder="Enter new password"
                            />
                          </div>
                          <div className="space-y-2">
                            <Label>Confirm New Password</Label>
                            <PasswordInput
                              value={adminResetPassword.confirmPassword}
                              onChange={(e) => setAdminResetPassword(prev => ({ ...prev, confirmPassword: e.target.value }))}
                              placeholder="Confirm new password"
                            />
                          </div>
                          <Button
                            onClick={resetUserPasswordFromAdmin}
                            disabled={resettingPassword}
                            className="w-full"
                          >
                            {resettingPassword ? 'Resetting...' : 'Reset Password'}
                          </Button>
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500">Select a user from the left list to reset password.</p>
                      )}
                    </CardContent>
                  </Card>
                </div>
              </CardContent>
            </Card>
            </div>
            )}

            {/* Feedback Tab */}
            {activeTab === 'feedback' && (
            <div>
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <MailCheck className="w-5 h-5" />
                  User Feedback
                </CardTitle>
                <p className="text-sm text-gray-600">Includes forgot-password contact admin requests.</p>
              </CardHeader>
              <CardContent>
                {loadingFeedback ? (
                  <div className="flex justify-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  </div>
                ) : (
                  <ScrollArea className="h-[600px]">
                    <div className="space-y-4">
                      {feedback.map((fb) => (
                        <div key={fb.id} className="p-4 border rounded-lg bg-white">
                          <div className="flex justify-between items-start mb-2">
                            <div>
                              <p className="font-semibold">{fb.sender?.username || fb.sender_email || 'Guest User'}</p>
                              <p className="text-xs text-gray-500">{new Date(fb.created_at).toLocaleString()}</p>
                              {fb.source === 'forgot_password' && (
                                <Badge variant="outline" className="mt-1">Forgot Password</Badge>
                              )}
                            </div>
                            <Badge variant={fb.status === 'pending' ? 'default' : 'secondary'}>
                              {fb.status}
                            </Badge>
                          </div>
                          <p className="text-gray-700 mb-3 whitespace-pre-line">{fb.message}</p>
                          {fb.status === 'pending' && (
                            <div className="flex gap-2">
                              <Button size="sm" onClick={() => updateFeedbackStatus(fb.id, 'reviewed')}>
                                Mark Reviewed
                              </Button>
                              <Button size="sm" variant="outline" onClick={() => updateFeedbackStatus(fb.id, 'resolved')}>
                                Mark Resolved
                              </Button>
                            </div>
                          )}
                        </div>
                      ))}
                      {feedback.length === 0 && (
                        <p className="text-center text-gray-500 py-8">No feedback yet</p>
                      )}
                    </div>
                  </ScrollArea>
                )}
              </CardContent>
            </Card>
            </div>
            )}

            {/* Audit Logs Tab */}
            {activeTab === 'audit-logs' && (
            <div>
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Shield className="w-5 h-5" />
                  Audit Logs
                </CardTitle>
                <p className="text-sm text-gray-600">View all system activities and user actions</p>
              </CardHeader>
              <CardContent>
                {loadingAuditLogs ? (
                  <div className="flex justify-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  </div>
                ) : (
                  <ScrollArea className="h-[600px]">
                    <div className="space-y-2">
                      {auditLogs.map((log, idx) => (
                        <div key={log.id || idx} className="p-3 border-l-4 border-blue-500 bg-white rounded shadow-sm">
                          <div className="flex justify-between items-start">
                            <div>
                              <p className="font-medium">
                                <span className="text-blue-600">{log.actor?.username || 'System'}</span>
                                {' '}{log.action?.replace(/_/g, ' ')}
                              </p>
                              <p className="text-xs text-gray-500">{new Date(log.created_at).toLocaleString()}</p>
                              {log.details && (
                                <p className="text-xs text-gray-400 mt-1">
                                  {JSON.stringify(log.details).substring(0, 100)}...
                                </p>
                              )}
                            </div>
                            <Badge variant="outline">{log.subject_type}</Badge>
                          </div>
                        </div>
                      ))}
                      {auditLogs.length === 0 && (
                        <p className="text-center text-gray-500 py-8">No audit logs yet</p>
                      )}
                    </div>
                  </ScrollArea>
                )}
              </CardContent>
            </Card>
            </div>
            )}

            {/* Notifications/Banner Tab */}
            {activeTab === 'notifications' && (
            <div className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <AlertTriangle className="w-5 h-5" />
                  Create Banner Notification
                </CardTitle>
                <p className="text-sm text-gray-600">Send notifications/banners to specific users, rooms, or all users</p>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <Label>Title</Label>
                    <Input
                      placeholder="Notification title..."
                      value={newNotification.title}
                      onChange={(e) => setNewNotification({...newNotification, title: e.target.value})}
                    />
                  </div>
                  <div>
                    <Label>Message</Label>
                    <Textarea
                      placeholder="Notification message..."
                      value={newNotification.message}
                      onChange={(e) => setNewNotification({...newNotification, message: e.target.value})}
                      rows={3}
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label>Target Type</Label>
                      <select
                        className="w-full p-2 border rounded"
                        value={newNotification.target_type}
                        onChange={(e) => setNewNotification({...newNotification, target_type: e.target.value})}
                      >
                        <option value="all">All Users</option>
                        <option value="room">Specific Room</option>
                        <option value="user">Specific User</option>
                      </select>
                    </div>
                    {newNotification.target_type !== 'all' && (
                      <div>
                        <Label>{newNotification.target_type === 'room' ? 'Room Name' : 'Username'}</Label>
                        <Input
                          placeholder={`Search ${newNotification.target_type}...`}
                          value={newNotification.target_id}
                          onChange={(e) => setNewNotification({...newNotification, target_id: e.target.value})}
                        />
                      </div>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label>Duration (hours)</Label>
                      <Input
                        type="number"
                        min="1"
                        max="720"
                        value={newNotification.duration_hours}
                        onChange={(e) => setNewNotification({...newNotification, duration_hours: parseInt(e.target.value)})}
                      />
                    </div>
                    <div>
                      <Label>Banner Color</Label>
                      <div className="flex gap-2">
                        <Input
                          type="color"
                          value={newNotification.color}
                          onChange={(e) => setNewNotification({...newNotification, color: e.target.value})}
                          className="w-16 h-10 p-1"
                        />
                        <Input
                          value={newNotification.color}
                          onChange={(e) => setNewNotification({...newNotification, color: e.target.value})}
                          className="flex-1"
                        />
                      </div>
                    </div>
                  </div>
                  <Button onClick={createNotification} className="w-full">
                    Create Notification
                  </Button>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Active Notifications ({notifications.filter(n => n.is_active).length})</CardTitle>
              </CardHeader>
              <CardContent>
                <ScrollArea className="h-[400px]">
                  <div className="space-y-3">
                    {notifications.map((notification) => (
                      <div 
                        key={notification.id} 
                        className="p-4 border rounded-lg"
                        style={{ borderLeftColor: notification.color, borderLeftWidth: '4px' }}
                      >
                        <div className="flex justify-between items-start">
                          <div>
                            <p className="font-semibold">{notification.title}</p>
                            <p className="text-sm text-gray-600">{notification.message}</p>
                            <div className="flex gap-2 mt-2">
                              <Badge variant="outline">
                                {notification.target_type === 'all' ? 'All Users' : `${notification.target_type}: ${notification.target_id}`}
                              </Badge>
                              <Badge variant={notification.is_active ? 'default' : 'secondary'}>
                                {notification.is_active ? 'Active' : 'Expired'}
                              </Badge>
                            </div>
                            <p className="text-xs text-gray-400 mt-1">
                              Expires: {new Date(notification.expires_at).toLocaleString()}
                            </p>
                          </div>
                          <Button 
                            variant="destructive" 
                            size="sm"
                            onClick={() => deleteNotification(notification.id)}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>
                    ))}
                    {notifications.length === 0 && (
                      <p className="text-center text-gray-500 py-8">No notifications</p>
                    )}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>
            </div>
            )}

            {/* Leaderboard Tab */}
            {activeTab === 'leaderboard' && (
            <div>
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Crown className="w-5 h-5 text-yellow-500" />
                  User Leaderboard
                </CardTitle>
                <div className="flex gap-2 mt-4">
                  <Button
                    variant={leaderboardFilter === 'coins' ? 'default' : 'outline'}
                    size="sm"
                    onClick={() => setLeaderboardFilter('coins')}
                  >
                    Coins
                  </Button>
                  <Button
                    variant={leaderboardFilter === 'logins' ? 'default' : 'outline'}
                    size="sm"
                    onClick={() => setLeaderboardFilter('logins')}
                  >
                    Logins
                  </Button>
                  <Button
                    variant={leaderboardFilter === 'friends' ? 'default' : 'outline'}
                    size="sm"
                    onClick={() => setLeaderboardFilter('friends')}
                  >
                    Friends
                  </Button>
                  <Button
                    variant={leaderboardFilter === 'rooms' ? 'default' : 'outline'}
                    size="sm"
                    onClick={() => setLeaderboardFilter('rooms')}
                  >
                    Rooms
                  </Button>
                </div>
              </CardHeader>
              <CardContent>
                {loadingLeaderboard ? (
                  <div className="flex justify-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  </div>
                ) : (
                  <ScrollArea className="h-[600px]">
                    <div className="space-y-2">
                      {leaderboard.map((entry, idx) => (
                        <div key={entry.user_id || idx} className="flex items-center gap-4 p-4 border rounded-lg bg-white">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold ${
                            idx === 0 ? 'bg-yellow-400 text-white' :
                            idx === 1 ? 'bg-gray-300 text-gray-800' :
                            idx === 2 ? 'bg-amber-600 text-white' :
                            'bg-gray-100 text-gray-600'
                          }`}>
                            {idx + 1}
                          </div>
                          <div className="flex-1">
                            <p className="font-semibold">{entry.username}</p>
                            <p className="text-sm text-gray-500">
                              {leaderboardFilter === 'coins' && `Coins: ${entry.coins || 0}`}
                              {leaderboardFilter === 'logins' && `Logins: ${entry.login_count || 0}`}
                              {leaderboardFilter === 'friends' && `Friends: ${entry.friend_count || 0}`}
                              {leaderboardFilter === 'rooms' && `Rooms: ${entry.room_created_count || 0}`}
                            </p>
                          </div>
                          <Badge variant="outline">{entry.role}</Badge>
                        </div>
                      ))}
                      {leaderboard.length === 0 && (
                        <p className="text-center text-gray-500 py-8">No leaderboard data</p>
                      )}
                    </div>
                  </ScrollArea>
                )}
              </CardContent>
            </Card>
            </div>
            )}

            {/* Coin Management Tab */}
            {activeTab === 'coin-management' && (
            <div className="space-y-4">
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Coins className="w-5 h-5 text-yellow-500" />
                    Coin Management
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-3">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <Input placeholder="User ID / username / display name" value={coinAction.user_id} onChange={(e) => setCoinAction(prev => ({ ...prev, user_id: e.target.value }))} />
                    <Input type="number" min="1" value={coinAction.amount} onChange={(e) => setCoinAction(prev => ({ ...prev, amount: Number(e.target.value || 0) }))} />
                    <Input placeholder="Reason" value={coinAction.reason} onChange={(e) => setCoinAction(prev => ({ ...prev, reason: e.target.value }))} />
                  </div>
                  <div className="flex gap-2">
                    <Button onClick={giftCoins}>Gift Coins</Button>
                    <Button variant="destructive" onClick={cutCoins}>Cut Coins</Button>
                    <Button variant="outline" onClick={loadCoinUsers}>Refresh</Button>
                  </div>
                </CardContent>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle>User Coin Wallets</CardTitle>
                </CardHeader>
                <CardContent>
                  <ScrollArea className="h-[420px]">
                    <div className="space-y-2">
                      {coinUsers.map((u) => (
                        <div
                          key={u.id}
                          className="p-3 border rounded-lg bg-white flex items-center justify-between cursor-pointer hover:bg-gray-50"
                          onClick={() => setCoinAction(prev => ({ ...prev, user_id: u.id }))}
                          title={`Select ${u.display_name || u.username}`}
                        >
                          <div>
                            <p className="font-semibold">{u.display_name || u.username}</p>
                            <p className="text-xs text-gray-500">{u.id}</p>
                          </div>
                          <Badge>{u.coins || 0} coins</Badge>
                        </div>
                      ))}
                    </div>
                  </ScrollArea>
                </CardContent>
              </Card>
            </div>
            )}

            {/* VoIP Tab */}
            {activeTab === 'voip' && (
            <div className="space-y-4">
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Phone className="w-5 h-5 text-blue-500" />
                    VoIP Call Logs
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="mb-3">
                    <Button variant="outline" onClick={loadVoipLogs}>Refresh Logs</Button>
                  </div>
                  <ScrollArea className="h-[500px]">
                    <div className="space-y-2">
                      {voipLogs.map((call) => (
                        <div key={call.id} className="p-3 border rounded-lg bg-white">
                          <div className="flex items-center justify-between">
                            <p className="font-semibold">{call.scope?.toUpperCase()} call</p>
                            <Badge variant={call.status === 'active' ? 'default' : 'secondary'}>{call.status}</Badge>
                          </div>
                          <p className="text-xs text-gray-500">Target: {call.scope === 'pm' ? formatUserRef(call.target_id) : (call.target_id || '-')}</p>
                          <p className="text-xs text-gray-500">Host: {formatUserRef(call.host_id)}</p>
                          <p className="text-xs text-gray-500">Participants: {(call.participants || []).length}</p>
                          <p className="text-xs text-gray-500 break-all">Participant Users: {(call.participants || []).map((id) => formatUserRef(id)).join(', ') || '-'}</p>
                          {call.scope === 'pm' && (
                            <p className="text-xs text-gray-500 break-all">PM Users: {formatUserRef(call.host_id)} ↔ {formatUserRef(call.target_id)}</p>
                          )}
                        </div>
                      ))}
                      {voipLogs.length === 0 && (
                        <p className="text-center text-gray-500 py-8">No call logs</p>
                      )}
                    </div>
                  </ScrollArea>
                </CardContent>
              </Card>
            </div>
            )}

            {/* IP Monitor Tab */}
            {activeTab === 'ip-monitor' && (
            <div className="space-y-4">
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Shield className="w-5 h-5 text-indigo-600" />
                    IP Monitor
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="flex gap-2 mb-3">
                    <Button variant="outline" onClick={loadIpMonitor}>Refresh</Button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div className="p-3 rounded border bg-white">
                      <p className="text-xs text-gray-500">Logs</p>
                      <p className="text-xl font-semibold">{ipMonitor?.summary?.log_count || 0}</p>
                    </div>
                    <div className="p-3 rounded border bg-white">
                      <p className="text-xs text-gray-500">Users With Multiple IPs</p>
                      <p className="text-xl font-semibold">{ipMonitor?.summary?.users_with_multi_ips || 0}</p>
                    </div>
                    <div className="p-3 rounded border bg-white">
                      <p className="text-xs text-gray-500">Shared IP Groups</p>
                      <p className="text-xl font-semibold">{ipMonitor?.summary?.shared_ip_groups || 0}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Users With Multiple IPs</CardTitle>
                </CardHeader>
                <CardContent>
                  <ScrollArea className="h-[240px]">
                    <div className="space-y-2">
                      {(ipMonitor?.multi_ip_users || []).map((item) => (
                        <div key={item.user_id} className="p-3 border rounded-lg bg-white">
                          <p className="font-semibold">{formatUserRef(item.user_id)}</p>
                          <p className="text-xs text-gray-500">{item.ip_count} IPs</p>
                          <p className="text-xs text-gray-500 break-all">{(item.ips || []).join(', ')}</p>
                        </div>
                      ))}
                      {(ipMonitor?.multi_ip_users || []).length === 0 && <p className="text-sm text-gray-500">No multi-IP users found</p>}
                    </div>
                  </ScrollArea>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Different Users On Same IP</CardTitle>
                </CardHeader>
                <CardContent>
                  <ScrollArea className="h-[240px]">
                    <div className="space-y-2">
                      {(ipMonitor?.shared_ip_groups || []).map((item) => (
                        <div key={item.ip_address} className="p-3 border rounded-lg bg-white">
                          <p className="font-semibold">{item.ip_address}</p>
                          <p className="text-xs text-gray-500">{item.user_count} users</p>
                          <p className="text-xs text-gray-500 break-all">{(item.user_ids || []).map((id) => formatUserRef(id)).join(', ')}</p>
                        </div>
                      ))}
                      {(ipMonitor?.shared_ip_groups || []).length === 0 && <p className="text-sm text-gray-500">No shared IP groups found</p>}
                    </div>
                  </ScrollArea>
                </CardContent>
              </Card>
            </div>
            )}

            {/* Custom Fonts Tab */}
            {activeTab === 'fonts' && (
            <div className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle>Upload Custom Font</CardTitle>
                <p className="text-sm text-gray-600">Upload TTF or OTF font files for use in room themes</p>
              </CardHeader>
              <CardContent>
                <div className="flex items-center gap-4">
                  <input
                    type="file"
                    accept=".ttf,.otf"
                    onChange={(e) => e.target.files[0] && uploadFont(e.target.files[0])}
                    className="flex-1"
                    disabled={uploadingFont}
                  />
                  {uploadingFont && (
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                  )}
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Installed Fonts ({customFonts.length})</CardTitle>
              </CardHeader>
              <CardContent>
                <ScrollArea className="h-[400px]">
                  <div className="space-y-3">
                    {customFonts.map((font) => (
                      <div key={font.id} className="flex items-center justify-between p-4 border rounded-lg bg-white">
                        <div>
                          <p className="font-semibold" style={{ fontFamily: font.font_family }}>{font.name}</p>
                          <p className="text-sm text-gray-500">Format: {font.format} | Family: {font.font_family}</p>
                          <p className="text-xs text-gray-400">Uploaded: {new Date(font.created_at).toLocaleDateString()}</p>
                        </div>
                        <Button variant="destructive" size="sm" onClick={() => deleteFont(font.id)}>
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    ))}
                    {customFonts.length === 0 && (
                      <p className="text-center text-gray-500 py-8">No custom fonts uploaded</p>
                    )}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>
            </div>
            )}

            {/* Email Verification Tab */}
            {activeTab === 'verification' && (
            <div>
            <Card>
              <CardHeader>
                <CardTitle>Email Verification Requests ({verificationRequests.filter(r => r.status === 'pending').length})</CardTitle>
                <p className="text-sm text-gray-600 mt-2">
                  Manage manual verification requests from users who are having trouble with automatic email verification.
                </p>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {verificationRequests.filter(r => r.status === 'pending').map((request) => (
                    <div key={request.id} className="flex items-center justify-between p-4 border rounded-lg bg-white shadow-sm">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <p className="font-semibold text-lg">{request.username}</p>
                          <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
                            Pending
                          </Badge>
                        </div>
                        <p className="text-sm text-gray-600">{request.email}</p>
                        <p className="text-xs text-gray-400 mt-2">
                          Requested: {new Date(request.request_date).toLocaleString()}
                        </p>
                        <div className="mt-2 text-xs text-gray-500">
                          <span className="font-medium">Current Status:</span>
                          {' '}Email: {request.current_email_verified ? '✓ Verified' : '✗ Unverified'}
                          {', '}Account: {request.current_is_verified ? '✓ Verified' : '✗ Unverified'}
                          {', '}Role: {request.current_role}
                        </div>
                        {request.message && (
                          <p className="text-sm text-gray-700 mt-2 italic">
                            &quot;{request.message}&quot;
                          </p>
                        )}
                      </div>
                      <div className="flex gap-2 ml-4">
                        <Button
                          onClick={() => grantVerification(request.id, request.username)}
                          className="bg-green-600 hover:bg-green-700"
                          data-testid={`grant-access-${request.id}`}
                        >
                          <MailCheck className="w-4 h-4 mr-2" />
                          Grant Access
                        </Button>
                        <Button
                          variant="destructive"
                          onClick={() => denyVerification(request.id, request.username)}
                          data-testid={`deny-${request.id}`}
                        >
                          <Trash2 className="w-4 h-4 mr-2" />
                          Deny
                        </Button>
                      </div>
                    </div>
                  ))}
                  {verificationRequests.filter(r => r.status === 'pending').length === 0 && (
                    <div className="text-center py-12">
                      <MailCheck className="w-16 h-16 mx-auto text-gray-300 mb-4" />
                      <p className="text-gray-500 text-lg">No pending verification requests</p>
                      <p className="text-gray-400 text-sm mt-2">
                        Users can request manual verification from the email verification banner on the chat page.
                      </p>
                    </div>
                  )}
                </div>
                
                {/* Show processed requests */}
                {verificationRequests.filter(r => r.status !== 'pending').length > 0 && (
                  <div className="mt-8">
                    <h3 className="text-lg font-semibold mb-4 text-gray-700">Processed Requests</h3>
                    <div className="space-y-2">
                      {verificationRequests.filter(r => r.status !== 'pending').slice(0, 5).map((request) => (
                        <div key={request.id} className="flex items-center justify-between p-3 border rounded bg-gray-50">
                          <div className="flex-1">
                            <div className="flex items-center gap-2">
                              <p className="font-medium">{request.username}</p>
                              <Badge 
                                variant={request.status === 'approved' ? 'default' : 'destructive'}
                                className={request.status === 'approved' ? 'bg-green-600' : ''}
                              >
                                {request.status}
                              </Badge>
                            </div>
                            <p className="text-xs text-gray-500 mt-1">
                              {request.status === 'approved' 
                                ? `Approved on ${new Date(request.approved_at).toLocaleString()}`
                                : `Denied on ${new Date(request.denied_at).toLocaleString()}`
                              }
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
            </div>
            )}

            {/* OTP Monitoring Tab */}
            {activeTab === 'otp-monitoring' && (
            <div className="space-y-6">
              {/* SMTP Health Status */}
              <Card>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2">
                      <Activity className="w-5 h-5" />
                      SMTP Email System Status
                    </CardTitle>
                    <div className="flex items-center gap-2">
                      <label className="flex items-center gap-2 text-sm">
                        <input
                          type="checkbox"
                          checked={autoRefreshOtp}
                          onChange={(e) => setAutoRefreshOtp(e.target.checked)}
                          className="rounded"
                        />
                        Auto-refresh (30s)
                      </label>
                      <Button
                        size="sm"
                        onClick={loadOtpStatus}
                        disabled={loadingOtpStatus}
                      >
                        {loadingOtpStatus ? 'Loading...' : 'Refresh Now'}
                      </Button>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  {otpStatus?.smtp_health ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* SMTP/Resend Health */}
                      <div className="p-4 border rounded-lg">
                        <h3 className="font-semibold mb-3 flex items-center gap-2">
                          <div className={`w-3 h-3 rounded-full ${
                            otpStatus.smtp_health?.status === 'healthy' ? 'bg-green-500' : 'bg-red-500'
                          }`}></div>
                          Email Service (Resend API)
                        </h3>
                        <div className="space-y-2 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Status:</span>
                            <Badge variant={otpStatus.smtp_health?.status === 'healthy' ? 'default' : 'destructive'}>
                              {otpStatus.smtp_health?.status || 'unknown'}
                            </Badge>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Connection:</span>
                            <span>{otpStatus.smtp_health?.connection ? '✅ OK' : '❌ Failed'}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Authentication:</span>
                            <span>{otpStatus.smtp_health?.authentication ? '✅ OK' : '❌ Failed'}</span>
                          </div>
                          {otpStatus.smtp_health?.error && (
                            <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700">
                              <strong>Error:</strong> {otpStatus.smtp_health.error}
                            </div>
                          )}
                          <div className="text-xs text-gray-500 mt-2">
                            Last checked: {otpStatus.smtp_health?.last_checked ? new Date(otpStatus.smtp_health.last_checked).toLocaleTimeString() : 'Never'}
                          </div>
                        </div>
                      </div>

                      {/* Configuration */}
                      <div className="p-4 border rounded-lg">
                        <h3 className="font-semibold mb-3">Configuration</h3>
                        <div className="space-y-2 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Dev Mode:</span>
                            <Badge variant={otpStatus?.dev_mode ? 'destructive' : 'default'}>
                              {otpStatus?.dev_mode ? 'ON (Emails Simulated)' : 'OFF (Live Resend)'}
                            </Badge>
                          </div>
                          <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded text-xs">
                            <p className="text-blue-800">
                              {otpStatus?.dev_mode 
                                ? '🔧 Development Mode: OTP emails are logged but not sent'
                                : '📧 Production Mode: OTP emails are sent via Resend API'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-400">
                      <Activity className="w-12 h-12 mx-auto mb-3 animate-pulse" />
                      <p>Click &quot;Refresh Now&quot; to check email service status</p>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Statistics */}
              {otpStatus?.statistics?.last_24_hours && (
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  {/* Total Sent (24h) */}
                  <Card>
                    <CardContent className="pt-6">
                      <div className="text-center">
                        <p className="text-3xl font-bold text-blue-600">{otpStatus.statistics.last_24_hours.total_sent || 0}</p>
                        <p className="text-sm text-gray-600 mt-1">Total Sent (24h)</p>
                      </div>
                    </CardContent>
                  </Card>

                  {/* Verified (24h) */}
                  <Card>
                    <CardContent className="pt-6">
                      <div className="text-center">
                        <p className="text-3xl font-bold text-green-600">{otpStatus.statistics.last_24_hours.verified || 0}</p>
                        <p className="text-sm text-gray-600 mt-1">Verified (24h)</p>
                      </div>
                    </CardContent>
                  </Card>

                  {/* Success Rate (24h) */}
                  <Card>
                    <CardContent className="pt-6">
                      <div className="text-center">
                        <p className="text-3xl font-bold text-green-600">{otpStatus.statistics.last_24_hours.success_rate || 0}%</p>
                        <p className="text-sm text-gray-600 mt-1">Success Rate (24h)</p>
                      </div>
                    </CardContent>
                  </Card>

                  {/* Pending (24h) */}
                  <Card>
                    <CardContent className="pt-6">
                      <div className="text-center">
                        <p className="text-3xl font-bold text-yellow-600">{otpStatus.statistics.last_24_hours.pending || 0}</p>
                        <p className="text-sm text-gray-600 mt-1">Pending (24h)</p>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              )}

              {/* Recent OTP Attempts */}
              {otpStatus && otpStatus.recent_attempts && (
                <Card>
                  <CardHeader>
                    <CardTitle>Recent OTP Attempts (Last 20)</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <ScrollArea className="h-96">
                      <div className="space-y-2">
                        {otpStatus.recent_attempts.map((otp, idx) => (
                          <div key={idx} className="p-3 border rounded-lg flex items-center justify-between hover:bg-gray-50">
                            <div className="flex-1">
                              <p className="font-mono text-sm">{otp.email}</p>
                              <p className="text-xs text-gray-500">
                                Created: {new Date(otp.created_at).toLocaleString()}
                              </p>
                            </div>
                            <div className="flex items-center gap-3">
                              <div className="text-right text-xs">
                                <p className="text-gray-600">Attempts: {otp.attempts}/3</p>
                                <p className={`${
                                  new Date(otp.expires_at) > new Date() ? 'text-green-600' : 'text-red-600'
                                }`}>
                                  {new Date(otp.expires_at) > new Date() ? 'Valid' : 'Expired'}
                                </p>
                              </div>
                              <Badge variant={otp.verified ? 'default' : 'secondary'}>
                                {otp.verified ? '✅ Verified' : '⏳ Pending'}
                              </Badge>
                            </div>
                          </div>
                        ))}
                        {otpStatus.recent_attempts.length === 0 && (
                          <div className="text-center py-8 text-gray-400">
                            <p>No recent OTP attempts</p>
                          </div>
                        )}
                      </div>
                    </ScrollArea>
                  </CardContent>
                </Card>
              )}

              {/* Last 24h Summary */}
              {otpStatus?.statistics?.last_24_hours && (
                <Card>
                  <CardHeader>
                    <CardTitle>Last 24 Hours Summary</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                      <div>
                        <p className="text-2xl font-bold">{otpStatus.statistics.last_24_hours.total_sent || 0}</p>
                        <p className="text-sm text-gray-600">Total Sent</p>
                      </div>
                      <div>
                        <p className="text-2xl font-bold text-green-600">{otpStatus.statistics.last_24_hours.verified || 0}</p>
                        <p className="text-sm text-gray-600">Verified</p>
                      </div>
                      <div>
                        <p className="text-2xl font-bold text-orange-600">{otpStatus.statistics.last_24_hours.expired || 0}</p>
                        <p className="text-sm text-gray-600">Expired</p>
                      </div>
                      <div>
                        <p className="text-2xl font-bold text-yellow-600">{otpStatus.statistics.last_24_hours.pending || 0}</p>
                        <p className="text-sm text-gray-600">Pending</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}
            </div>
            )}

            {/* File Editor Tab */}

            {/* Performance Metrics Tab */}
            {activeTab === 'performance' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold">Performance Metrics</h2>
                    <p className="text-gray-600">Real-time system performance monitoring</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <label className="flex items-center gap-2 text-sm">
                      <input
                        type="checkbox"
                        checked={autoRefreshMetrics}
                        onChange={(e) => setAutoRefreshMetrics(e.target.checked)}
                        className="rounded"
                      />
                      Auto-refresh (10s)
                    </label>
                    <Button onClick={loadPerformanceMetrics} disabled={loadingMetrics}>
                      {loadingMetrics ? 'Loading...' : 'Refresh'}
                    </Button>
                  </div>
                </div>

                {performanceMetrics && (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* WebSocket Metrics */}
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <Activity className="w-5 h-5" />
                          WebSocket Connections
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="space-y-3">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Active Now:</span>
                          <span className="text-2xl font-bold text-green-600">
                            {performanceMetrics.websocket.active_connections}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Peak Today:</span>
                          <span className="text-lg font-semibold">
                            {performanceMetrics.websocket.peak_connections}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Total Errors:</span>
                          <span className={`text-lg font-semibold ${
                            performanceMetrics.websocket.total_errors > 0 ? 'text-red-600' : 'text-green-600'
                          }`}>
                            {performanceMetrics.websocket.total_errors}
                          </span>
                        </div>
                      </CardContent>
                    </Card>

                    {/* Message Metrics */}
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <MessageSquare className="w-5 h-5" />
                          Message Performance
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="space-y-3">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Total Sent:</span>
                          <span className="text-2xl font-bold text-blue-600">
                            {performanceMetrics.messages.total_sent}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Avg Latency:</span>
                          <span className={`text-lg font-semibold ${
                            performanceMetrics.messages.average_latency_ms < 100 ? 'text-green-600' : 
                            performanceMetrics.messages.average_latency_ms < 500 ? 'text-yellow-600' : 'text-red-600'
                          }`}>
                            {performanceMetrics.messages.average_latency_ms}ms
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Msgs/Minute:</span>
                          <span className="text-lg font-semibold">
                            {performanceMetrics.messages.messages_per_minute}
                          </span>
                        </div>
                      </CardContent>
                    </Card>

                    {/* System Metrics */}
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <Activity className="w-5 h-5" />
                          System Health
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="space-y-3">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Uptime:</span>
                          <span className="text-lg font-semibold text-green-600">
                            {performanceMetrics.system.uptime_formatted}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Total Requests:</span>
                          <span className="text-lg font-semibold">
                            {performanceMetrics.system.total_requests}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Error Rate:</span>
                          <span className={`text-lg font-semibold ${
                            performanceMetrics.system.error_rate < 1 ? 'text-green-600' : 
                            performanceMetrics.system.error_rate < 5 ? 'text-yellow-600' : 'text-red-600'
                          }`}>
                            {performanceMetrics.system.error_rate}%
                          </span>
                        </div>
                      </CardContent>
                    </Card>

                    {/* Database Stats */}
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <Database className="w-5 h-5" />
                          Database Statistics
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="space-y-3">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Total Users:</span>
                          <span className="text-lg font-semibold">
                            {performanceMetrics.database.total_users}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Total Rooms:</span>
                          <span className="text-lg font-semibold">
                            {performanceMetrics.database.total_rooms}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Total Messages:</span>
                          <span className="text-lg font-semibold">
                            {performanceMetrics.database.total_messages}
                          </span>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                )}

                {loadingMetrics && !performanceMetrics && (
                  <div className="text-center py-12">
                    <p className="text-gray-600">Loading performance metrics...</p>
                  </div>
                )}
              </div>
            )}

            {/* Endpoints Health Tab */}
            {activeTab === 'endpoints-health' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold">Endpoints Health Monitor</h2>
                    <p className="text-gray-600">Monitor API endpoint performance and health status</p>
                  </div>
                  <Button onClick={loadEndpointsHealth} disabled={loadingEndpointsHealth}>
                    {loadingEndpointsHealth ? 'Loading...' : 'Refresh'}
                  </Button>
                </div>

                {endpointsHealth && (
                  <>
                    {/* Summary Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <Card>
                        <CardContent className="pt-6">
                          <div className="text-center">
                            <div className="text-3xl font-bold text-green-600">{endpointsHealth.summary.healthy}</div>
                            <div className="text-sm text-gray-600">Healthy</div>
                          </div>
                        </CardContent>
                      </Card>
                      <Card>
                        <CardContent className="pt-6">
                          <div className="text-center">
                            <div className="text-3xl font-bold text-yellow-600">{endpointsHealth.summary.warning}</div>
                            <div className="text-sm text-gray-600">Warning</div>
                          </div>
                        </CardContent>
                      </Card>
                      <Card>
                        <CardContent className="pt-6">
                          <div className="text-center">
                            <div className="text-3xl font-bold text-orange-600">{endpointsHealth.summary.degraded}</div>
                            <div className="text-sm text-gray-600">Degraded</div>
                          </div>
                        </CardContent>
                      </Card>
                      <Card>
                        <CardContent className="pt-6">
                          <div className="text-center">
                            <div className="text-3xl font-bold text-red-600">{endpointsHealth.summary.critical}</div>
                            <div className="text-sm text-gray-600">Critical</div>
                          </div>
                        </CardContent>
                      </Card>
                    </div>

                    {/* Endpoints List */}
                    <Card>
                      <CardHeader>
                        <CardTitle>API Endpoints ({endpointsHealth.summary.total_endpoints})</CardTitle>
                      </CardHeader>
                      <CardContent>
                        <ScrollArea className="h-[500px]">
                          <div className="space-y-3">
                            {endpointsHealth.endpoints.map((endpoint, idx) => (
                              <div key={idx} className="border rounded-lg p-4 hover:bg-gray-50">
                                <div className="flex items-center justify-between mb-2">
                                  <div className="flex items-center gap-2">
                                    <Badge className={
                                      endpoint.health_status === 'healthy' ? 'bg-green-500' :
                                      endpoint.health_status === 'warning' ? 'bg-yellow-500' :
                                      endpoint.health_status === 'degraded' ? 'bg-orange-500' : 'bg-red-500'
                                    }>
                                      {endpoint.health_status.toUpperCase()}
                                    </Badge>
                                    <code className="text-sm font-mono">{endpoint.path}</code>
                                  </div>
                                  <div className="text-sm text-gray-600">
                                    {endpoint.avg_response_time_ms.toFixed(2)}ms avg
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                                  <div>
                                    <span className="text-gray-600">Total: </span>
                                    <span className="font-semibold">{endpoint.total_requests}</span>
                                  </div>
                                  <div>
                                    <span className="text-gray-600">Success: </span>
                                    <span className="font-semibold text-green-600">{endpoint.success_count}</span>
                                  </div>
                                  <div>
                                    <span className="text-gray-600">Errors: </span>
                                    <span className="font-semibold text-red-600">{endpoint.error_count}</span>
                                  </div>
                                  <div>
                                    <span className="text-gray-600">Success Rate: </span>
                                    <span className={`font-semibold ${
                                      endpoint.success_rate >= 95 ? 'text-green-600' : 
                                      endpoint.success_rate >= 80 ? 'text-yellow-600' : 'text-red-600'
                                    }`}>
                                      {endpoint.success_rate}%
                                    </span>
                                  </div>
                                </div>
                                {endpoint.last_error && (
                                  <div className="mt-2 p-2 bg-red-50 rounded text-sm">
                                    <span className="font-semibold text-red-600">Last Error: </span>
                                    <span className="text-gray-700">{endpoint.last_error.timestamp}</span>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </ScrollArea>
                      </CardContent>
                    </Card>
                  </>
                )}
              </div>
            )}

            {/* Service Control Tab */}
            {activeTab === 'service-control' && (
              <div className="space-y-6">
                <div>
                  <h2 className="text-2xl font-bold">Service Control Panel</h2>
                  <p className="text-gray-600">Manage backend and frontend services, view logs</p>
                </div>

                {/* Services Status */}
                <Card>
                  <CardHeader>
                    <div className="flex items-center justify-between">
                      <CardTitle>Services Status</CardTitle>
                      <Button onClick={loadServices} disabled={loadingServices} size="sm">
                        {loadingServices ? 'Loading...' : 'Refresh'}
                      </Button>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      {services && services.length > 0 ? services.map((service, idx) => (
                        <div key={idx} className="border rounded-lg p-4 hover:border-blue-300 transition-colors">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <Badge className={
                                service.status === 'RUNNING' ? 'bg-green-500 hover:bg-green-600' : 
                                service.status === 'STOPPED' ? 'bg-gray-500 hover:bg-gray-600' :
                                service.status === 'FATAL' ? 'bg-red-500 hover:bg-red-600' :
                                'bg-yellow-500 hover:bg-yellow-600'
                              }>
                                {service.status}
                              </Badge>
                              <div>
                                <div className="font-semibold capitalize">{service.name}</div>
                                <div className="text-sm text-gray-600">{service.uptime}</div>
                              </div>
                            </div>
                            <div className="flex gap-2">
                              <Button 
                                size="sm" 
                                variant="outline"
                                onClick={() => controlService(service.name, 'start')}
                                disabled={service.status === 'RUNNING' || service.status === 'FATAL'}
                                className="min-w-[70px]"
                              >
                                Start
                              </Button>
                              <Button 
                                size="sm" 
                                variant="outline"
                                onClick={() => controlService(service.name, 'restart')}
                                disabled={service.status === 'STOPPED' || service.status === 'FATAL'}
                                className="min-w-[70px]"
                              >
                                Restart
                              </Button>
                              <Button 
                                size="sm" 
                                variant="destructive"
                                onClick={() => controlService(service.name, 'stop')}
                                disabled={service.status === 'STOPPED' || service.status === 'FATAL'}
                                className="min-w-[70px]"
                              >
                                Stop
                              </Button>
                            </div>
                          </div>
                        </div>
                      )) : (
                        <div className="text-center py-8 text-gray-500">
                          {loadingServices ? (
                            <div className="flex items-center justify-center gap-2">
                              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900"></div>
                              <span>Loading services...</span>
                            </div>
                          ) : (
                            <div>
                              <p className="mb-2">No services found</p>
                              <Button onClick={loadServices} variant="outline" size="sm">
                                Try Again
                              </Button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>

                {/* Service Logs */}
                <Card>
                  <CardHeader>
                    <CardTitle>Service Logs</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div className="flex gap-4">
                      <div className="flex-1">
                        <Label>Service</Label>
                        <select 
                          className="w-full p-2 border rounded"
                          value={selectedServiceForLogs}
                          onChange={(e) => setSelectedServiceForLogs(e.target.value)}
                        >
                          <option value="backend">Backend</option>
                          <option value="frontend">Frontend</option>
                        </select>
                      </div>
                      <div className="flex-1">
                        <Label>Log Type</Label>
                        <select 
                          className="w-full p-2 border rounded"
                          value={selectedLogType}
                          onChange={(e) => setSelectedLogType(e.target.value)}
                        >
                          <option value="out">Output (stdout)</option>
                          <option value="err">Errors (stderr)</option>
                        </select>
                      </div>
                      <div className="flex items-end">
                        <Button onClick={loadServiceLogs}>
                          Refresh Logs
                        </Button>
                      </div>
                    </div>
                    <ScrollArea className="h-[400px] w-full rounded border bg-black p-4">
                      <pre className="text-xs text-green-400 font-mono whitespace-pre-wrap">
                        {serviceLogs || 'No logs available'}
                      </pre>
                    </ScrollArea>
                  </CardContent>
                </Card>
              </div>
            )}

            {/* Badge Manager Tab */}
            {activeTab === 'badges' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold">Badge Management</h2>
                    <p className="text-gray-600">Create and manage user badges with #tags</p>
                  </div>
                  <Dialog open={createBadgeOpen} onOpenChange={setCreateBadgeOpen}>
                    <DialogTrigger asChild>
                      <Button>
                        <Shield className="w-4 h-4 mr-2" />
                        Create Badge
                      </Button>
                    </DialogTrigger>
                    <DialogContent>
                      <DialogHeader>
                        <DialogTitle>Create New Badge</DialogTitle>
                      </DialogHeader>
                      <div className="space-y-4">
                        <div>
                          <Label>Badge Name</Label>
                          <Input
                            value={newBadge.name}
                            onChange={(e) => setNewBadge({...newBadge, name: e.target.value})}
                            placeholder="e.g., Early Adopter"
                          />
                        </div>
                        <div>
                          <Label>Description</Label>
                          <Textarea
                            value={newBadge.description}
                            onChange={(e) => setNewBadge({...newBadge, description: e.target.value})}
                            placeholder="What does this badge represent?"
                          />
                        </div>
                        <div>
                          <Label>#Tag</Label>
                          <Input
                            value={newBadge.tag}
                            onChange={(e) => setNewBadge({...newBadge, tag: e.target.value})}
                            placeholder="e.g., #early or early"
                          />
                          <p className="text-xs text-gray-500 mt-1">Users earn this badge when they type this tag in chat</p>
                        </div>
                        <div>
                          <Label>Emoji Sequence</Label>
                          <Input
                            value={newBadge.emoji_sequence}
                            onChange={(e) => setNewBadge({...newBadge, emoji_sequence: e.target.value})}
                            placeholder="e.g., 🏆✨ or 👑💎🔥"
                            className="text-2xl"
                          />
                          <p className="text-xs text-gray-500 mt-1">Enter one or more emojis that will appear next to usernames</p>
                        </div>
                        <Button onClick={createBadge} className="w-full">
                          Create Badge
                        </Button>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>

                {/* Badges List */}
                <Card>
                  <CardHeader>
                    <CardTitle>All Badges ({badges.length})</CardTitle>
                  </CardHeader>
                  <CardContent>
                    {loadingBadges ? (
                      <div className="text-center py-8">
                        <Activity className="w-8 h-8 animate-spin mx-auto mb-2" />
                        <p className="text-gray-500">Loading badges...</p>
                      </div>
                    ) : badges.length === 0 ? (
                      <div className="text-center py-8">
                        <Shield className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                        <p className="text-gray-500">No badges yet. Create your first badge!</p>
                      </div>
                    ) : (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {badges.map((badge) => (
                          <div key={badge.id} className="border rounded-lg p-4 hover:bg-gray-50">
                            <div className="flex items-start gap-3">
                              <div className="text-4xl w-16 h-16 flex items-center justify-center bg-gray-100 rounded">
                                {badge.emoji_sequence || '🏅'}
                              </div>
                              <div className="flex-1">
                                <h3 className="font-semibold">{badge.name}</h3>
                                <p className="text-sm text-gray-600 mt-1">{badge.description}</p>
                                <div className="mt-2 flex items-center gap-2">
                                  <Badge variant="outline">{badge.tag}</Badge>
                                  <span className="text-lg">{badge.emoji_sequence}</span>
                                </div>
                                <p className="text-xs text-gray-400 mt-2">
                                  Created: {new Date(badge.created_at).toLocaleDateString()}
                                </p>
                              </div>
                            </div>
                            <div className="mt-3 flex justify-end">
                              <Button
                                size="sm"
                                variant="destructive"
                                onClick={() => deleteBadge(badge.id)}
                              >
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>
            )}

            {/* Web Traffic Tab */}
            {activeTab === 'traffic' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold">Web Traffic Report</h2>
                    <p className="text-gray-600">Monitor user activity and growth metrics</p>
                  </div>
                  <Button onClick={loadTrafficReport} disabled={loadingTraffic}>
                    {loadingTraffic ? 'Loading...' : 'Refresh'}
                  </Button>
                </div>

                {trafficReport && (
                  <>
                    {/* Today's Stats */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <Card>
                        <CardContent className="pt-6">
                          <div className="text-center">
                            <p className="text-3xl font-bold text-blue-600">{trafficReport.today.registrations}</p>
                            <p className="text-sm text-gray-600 mt-1">New Registrations Today</p>
                          </div>
                        </CardContent>
                      </Card>
                      <Card>
                        <CardContent className="pt-6">
                          <div className="text-center">
                            <p className="text-3xl font-bold text-green-600">{trafficReport.today.guest_logins}</p>
                            <p className="text-sm text-gray-600 mt-1">Guest Logins Today</p>
                          </div>
                        </CardContent>
                      </Card>
                      <Card>
                        <CardContent className="pt-6">
                          <div className="text-center">
                            <p className="text-3xl font-bold text-purple-600">{trafficReport.today.messages_sent}</p>
                            <p className="text-sm text-gray-600 mt-1">Messages Sent Today</p>
                          </div>
                        </CardContent>
                      </Card>
                    </div>

                    {/* Overall Stats */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Overall Statistics</CardTitle>
                      </CardHeader>
                      <CardContent>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                          <div className="text-center">
                            <p className="text-2xl font-bold">{trafficReport.overall.total_users}</p>
                            <p className="text-sm text-gray-600">Total Users</p>
                          </div>
                          <div className="text-center">
                            <p className="text-2xl font-bold text-green-600">{trafficReport.overall.active_users_24h}</p>
                            <p className="text-sm text-gray-600">Active (24h)</p>
                          </div>
                          <div className="text-center">
                            <p className="text-2xl font-bold text-yellow-600">{trafficReport.overall.premium_users}</p>
                            <p className="text-sm text-gray-600">Premium Users</p>
                          </div>
                          <div className="text-center">
                            <p className="text-2xl font-bold text-blue-600">{trafficReport.overall.total_rooms}</p>
                            <p className="text-sm text-gray-600">Total Rooms</p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>

                    {/* Daily Registrations Chart */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Registrations (Last 7 Days)</CardTitle>
                      </CardHeader>
                      <CardContent>
                        <div className="space-y-3">
                          {trafficReport.daily_registrations_7d.map((day, idx) => (
                            <div key={idx} className="flex items-center gap-3">
                              <div className="w-24 text-sm text-gray-600">{day.date}</div>
                              <div className="flex-1 bg-gray-100 rounded-full h-8 relative">
                                <div
                                  className="bg-blue-500 h-full rounded-full flex items-center justify-end px-2"
                                  style={{
                                    width: `${Math.max((day.count / Math.max(...trafficReport.daily_registrations_7d.map(d => d.count))) * 100, 5)}%`
                                  }}
                                >
                                  <span className="text-white text-sm font-semibold">{day.count}</span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </CardContent>
                    </Card>

                    <p className="text-sm text-gray-500 text-center">
                      Last updated: {new Date(trafficReport.timestamp).toLocaleString()}
                    </p>
                  </>
                )}
              </div>
            )}

            {/* ENV Variables Tab */}
            {activeTab === 'env-variables' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold">Environment Variables</h2>
                    <p className="text-gray-600">Manage backend and frontend environment configuration</p>
                  </div>
                  <div className="flex gap-2">
                    <Button onClick={loadEnvVariables} disabled={loadingEnv}>
                      {loadingEnv ? 'Loading...' : 'Refresh'}
                    </Button>
                    <Button variant="outline" onClick={() => exportEnvVariables(envTarget)}>
                      <Download className="w-4 h-4 mr-2" />
                      Export
                    </Button>
                    <Button 
                      variant="outline"
                      onClick={async () => {
                        if (window.confirm('Restart both backend and frontend services? This may cause brief downtime.')) {
                          try {
                            const token = localStorage.getItem('token');
                            await Promise.all([
                              axios.post(`${API}/admin/service-control`, { service: 'backend', action: 'restart' }, {
                                headers: { Authorization: `Bearer ${token}` }
                              }),
                              axios.post(`${API}/admin/service-control`, { service: 'frontend', action: 'restart' }, {
                                headers: { Authorization: `Bearer ${token}` }
                              })
                            ]);
                            toast.success('Services restarted successfully');
                          } catch (error) {
                            toast.error('Failed to restart services');
                          }
                        }
                      }}
                    >
                      <Settings className="w-4 h-4 mr-2" />
                      Restart Services
                    </Button>
                  </div>
                </div>

                {/* Target Selector */}
                <div className="flex gap-2">
                  <Button
                    variant={envTarget === 'backend' ? 'default' : 'outline'}
                    onClick={() => setEnvTarget('backend')}
                  >
                    Backend .env
                  </Button>
                  <Button
                    variant={envTarget === 'frontend' ? 'default' : 'outline'}
                    onClick={() => setEnvTarget('frontend')}
                  >
                    Frontend .env
                  </Button>
                </div>

                {/* ENV Variables Editor */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                      <span>{envTarget === 'backend' ? 'Backend' : 'Frontend'} Environment Variables</span>
                      <Button onClick={updateEnvVariables}>
                        <Save className="w-4 h-4 mr-2" />
                        Save Changes
                      </Button>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <ScrollArea className="h-[500px]">
                      <div className="space-y-3">
                        {Object.keys(editingEnv[envTarget] || {}).length === 0 ? (
                          <div className="text-center py-12">
                            <Settings className="w-12 h-12 mx-auto text-gray-400 mb-3" />
                            <p className="text-gray-600">No environment variables found</p>
                            <Button onClick={loadEnvVariables} className="mt-4">
                              Load Variables
                            </Button>
                          </div>
                        ) : (
                          Object.entries(editingEnv[envTarget] || {}).map(([key, value]) => {
                            const isMasked = value === '***MASKED***';
                            const showValue = showMaskedValues[`${envTarget}-${key}`];
                            return (
                              <div key={key} className="grid grid-cols-1 md:grid-cols-3 gap-3 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                                <div className="font-mono text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center">
                                  {key}
                                </div>
                                <div className="md:col-span-2 relative">
                                  <Input
                                    type={(isMasked && !showValue) ? 'password' : 'text'}
                                    value={value}
                                    onChange={(e) => {
                                      setEditingEnv({
                                        ...editingEnv,
                                        [envTarget]: {
                                          ...editingEnv[envTarget],
                                          [key]: e.target.value
                                        }
                                      });
                                    }}
                                    className="font-mono text-sm pr-10"
                                    placeholder={isMasked ? 'Masked for security' : 'Enter value'}
                                  />
                                  {isMasked && (
                                    <button
                                      type="button"
                                      onClick={() => setShowMaskedValues({
                                        ...showMaskedValues,
                                        [`${envTarget}-${key}`]: !showValue
                                      })}
                                      className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                    >
                                      {showValue ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </ScrollArea>

                    {Object.keys(editingEnv[envTarget] || {}).length > 0 && (
                      <div className="mt-4 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
                        <div className="flex items-start gap-2">
                          <AlertTriangle className="w-5 h-5 text-yellow-600 dark:text-yellow-500 flex-shrink-0 mt-0.5" />
                          <div className="text-sm text-yellow-800 dark:text-yellow-200">
                            <p className="font-semibold mb-1">Important Notes:</p>
                            <ul className="list-disc list-inside space-y-1">
                              <li>Changes require server restart to take effect</li>
                              <li>Masked values (passwords, secrets) won&apos;t be changed unless you enter a new value</li>
                              <li>Export before making changes for backup</li>
                              <li>Invalid values may cause application errors</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>
            )}

            {activeTab === 'fileeditor' && (
            <div>
            <Card>
              <CardHeader>
                <CardTitle>index.html Editor</CardTitle>
                <p className="text-sm text-gray-600 mt-2">
                  Edit the main HTML file. Changes will be backed up automatically. Path: {indexHtmlPath}
                </p>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <textarea
                    value={indexHtmlContent}
                    onChange={(e) => setIndexHtmlContent(e.target.value)}
                    className="w-full h-96 font-mono text-sm p-4 border rounded-lg bg-gray-50"
                    placeholder="Loading..."
                  />
                  <div className="flex gap-2 flex-wrap">
                    <Button 
                      onClick={saveIndexHtml}
                      disabled={savingFile}
                      className="bg-green-600 hover:bg-green-700"
                    >
                      {savingFile ? 'Saving...' : 'Save Changes'}
                    </Button>
                    <Button 
                      onClick={loadIndexHtml}
                      variant="outline"
                    >
                      Reload
                    </Button>
                    <Button 
                      onClick={() => applyUpdates('index_html')}
                      disabled={applyingUpdates}
                      className="bg-blue-600 hover:bg-blue-700"
                    >
                      {applyingUpdates ? 'Applying...' : '🔄 Apply Updates (Restart Frontend)'}
                    </Button>
                  </div>
                  <div className="text-sm text-yellow-600 bg-yellow-50 p-3 rounded">
                    ⚠️ Warning: Editing this file incorrectly may break the website. A backup will be created automatically.
                  </div>
                  <div className="text-sm text-blue-600 bg-blue-50 p-3 rounded">
                    💡 After saving changes, click "Apply Updates" to save to database. In production, changes apply on next deployment.
                  </div>
                </div>
              </CardContent>
            </Card>
            </div>
            )}

            {/* Meta Tags Tab */}
            {activeTab === 'metatags' && (
            <div>
            <Card>
              <CardHeader>
                <CardTitle>Meta Tags Manager</CardTitle>
                <p className="text-sm text-gray-600 mt-2">
                  Add custom meta tags to your website's &lt;head&gt; section. These are used for SEO, social sharing, and site verification.
                </p>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <Label className="text-sm font-medium mb-2 block">Meta Tags Script</Label>
                    <Textarea
                      value={metaTagsContent}
                      onChange={(e) => setMetaTagsContent(e.target.value)}
                      className="w-full h-64 font-mono text-sm"
                      placeholder={`<!-- Example meta tags -->
<meta name="description" content="Your site description here">
<meta name="keywords" content="keyword1, keyword2, keyword3">
<meta property="og:title" content="Your Site Title">
<meta property="og:description" content="Your site description">
<meta property="og:image" content="https://yoursite.com/image.jpg">
<meta name="twitter:card" content="summary_large_image">
<meta name="google-site-verification" content="your-verification-code">
<link rel="canonical" href="https://yoursite.com">`}
                    />
                    <p className="text-xs text-gray-500 mt-2">
                      Enter valid HTML meta tags. These will be inserted into the &lt;head&gt; section of index.html.
                    </p>
                  </div>
                  
                  {metaTagsLastUpdated && (
                    <p className="text-xs text-gray-400">
                      Last updated: {new Date(metaTagsLastUpdated).toLocaleString()}
                    </p>
                  )}
                  
                  <div className="flex gap-2 flex-wrap">
                    <Button 
                      onClick={saveMetaTags}
                      disabled={savingMetaTags}
                      className="bg-green-600 hover:bg-green-700"
                    >
                      <Save className="w-4 h-4 mr-2" />
                      {savingMetaTags ? 'Saving...' : 'Save Changes'}
                    </Button>
                    <Button 
                      onClick={loadMetaTags}
                      variant="outline"
                    >
                      Reload
                    </Button>
                    <Button 
                      onClick={() => applyUpdates('index_html')}
                      disabled={applyingUpdates}
                      className="bg-blue-600 hover:bg-blue-700"
                    >
                      {applyingUpdates ? 'Applying...' : '🔄 Update Settings (Restart Frontend)'}
                    </Button>
                  </div>
                  
                  <div className="text-sm text-yellow-600 bg-yellow-50 p-3 rounded">
                    ⚠️ Warning: Invalid meta tags may affect SEO or cause issues. Make sure your tags are properly formatted.
                  </div>
                  <div className="text-sm text-blue-600 bg-blue-50 p-3 rounded">
                    💡 After saving changes, click "Update Settings" to save to database and index.html. In production, changes apply on next deployment.
                  </div>
                  
                  <Card className="bg-gray-50">
                    <CardHeader className="pb-2">
                      <CardTitle className="text-sm">Common Meta Tags Examples</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <pre className="text-xs bg-white p-3 rounded border overflow-auto max-h-48">
{`<!-- Basic SEO -->
<meta name="description" content="Site description (150-160 chars)">
<meta name="keywords" content="keyword1, keyword2">
<meta name="author" content="Your Name">

<!-- Open Graph (Facebook, LinkedIn) -->
<meta property="og:type" content="website">
<meta property="og:title" content="Page Title">
<meta property="og:description" content="Page description">
<meta property="og:image" content="https://example.com/image.jpg">
<meta property="og:url" content="https://example.com">

<!-- Twitter Card -->
<meta name="twitter:card" content="summary_large_image">
<meta name="twitter:title" content="Page Title">
<meta name="twitter:description" content="Page description">
<meta name="twitter:image" content="https://example.com/image.jpg">

<!-- Google Site Verification -->
<meta name="google-site-verification" content="verification-code">

<!-- Favicon -->
<link rel="icon" type="image/png" href="/favicon.png">`}
                      </pre>
                    </CardContent>
                  </Card>
                </div>
              </CardContent>
            </Card>
            </div>
            )}

            {/* Database Editor Tab */}
            {activeTab === 'dbeditor' && (
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
              {/* Collections List */}
              <Card className="lg:col-span-1">
                <CardHeader>
                  <CardTitle>Collections ({dbCollections.length})</CardTitle>
                </CardHeader>
                <CardContent>
                  <ScrollArea className="h-96">
                    <div className="space-y-2">
                      {dbCollections.map((collection) => (
                        <div
                          key={collection.name}
                          onClick={() => loadDbCollectionData(collection.name)}
                          className={`p-3 rounded cursor-pointer hover:bg-gray-100 ${
                            selectedDbCollection === collection.name ? 'bg-blue-100 border-2 border-blue-500' : 'border'
                          }`}
                        >
                          <p className="font-semibold text-sm">{collection.name}</p>
                          <p className="text-xs text-gray-500">{collection.count} documents</p>
                        </div>
                      ))}
                    </div>
                  </ScrollArea>
                </CardContent>
              </Card>

              {/* Collection Data */}
              <Card className="lg:col-span-3">
                <CardHeader>
                  <CardTitle>
                    {selectedDbCollection || 'Select a collection'}
                    {selectedDbCollection && ` (${dbCollectionTotal} total)`}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {selectedDbCollection ? (
                    <ScrollArea className="h-96">
                      <pre className="text-xs bg-gray-50 p-4 rounded overflow-x-auto">
                        {JSON.stringify(dbCollectionData, null, 2)}
                      </pre>
                    </ScrollArea>
                  ) : (
                    <div className="text-center py-12 text-gray-400">
                      <Database className="w-16 h-16 mx-auto mb-4" />
                      <p>Select a collection to view its data</p>
                    </div>
                  )}
                </CardContent>
              </Card>
            </div>
            )}

            {/* Themes Tab */}
            {activeTab === 'themes' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Global Theme Settings */}
              <Card>
                <CardHeader>
                  <CardTitle>Global Theme Settings</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <Label>Font Size</Label>
                    <Input
                      type="number"
                      min="12"
                      max="24"
                      value={globalTheme.font_size}
                      onChange={(e) => setGlobalTheme({...globalTheme, font_size: parseInt(e.target.value)})}
                    />
                  </div>
                  <div>
                    <Label>Font Color</Label>
                    <Input
                      type="color"
                      value={globalTheme.font_color}
                      onChange={(e) => setGlobalTheme({...globalTheme, font_color: e.target.value})}
                    />
                  </div>
                  <div>
                    <Label>Notification Color</Label>
                    <Input
                      type="color"
                      value={globalTheme.notification_color}
                      onChange={(e) => setGlobalTheme({...globalTheme, notification_color: e.target.value})}
                    />
                  </div>
                  <div>
                    <Label>Chat Bubble (Own Messages)</Label>
                    <Input
                      type="color"
                      value={globalTheme.chat_bubble_own}
                      onChange={(e) => setGlobalTheme({...globalTheme, chat_bubble_own: e.target.value})}
                    />
                  </div>
                  <div>
                    <Label>Chat Bubble (Other Messages)</Label>
                    <Input
                      type="color"
                      value={globalTheme.chat_bubble_other}
                      onChange={(e) => setGlobalTheme({...globalTheme, chat_bubble_other: e.target.value})}
                    />
                  </div>
                  <Button onClick={updateGlobalTheme}>Save Global Theme</Button>
                </CardContent>
              </Card>

              {/* Font Preview */}
              <Card>
                <CardHeader>
                  <CardTitle>Available Fonts for Themes</CardTitle>
                  <p className="text-sm text-gray-600">
                    Fonts uploaded in the &quot;Fonts&quot; tab are available for room themes.
                    Go to Fonts tab to upload custom TTF/OTF fonts.
                  </p>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <Label>Custom Fonts ({customFonts.length})</Label>
                    <ScrollArea className="h-48 border rounded p-2 mt-2">
                      {customFonts.map((font) => (
                        <div key={font.id} className="flex items-center justify-between p-2 border-b">
                          <span style={{fontFamily: font.font_family}}>{font.name}</span>
                          <Badge variant="outline">{font.format?.toUpperCase()}</Badge>
                        </div>
                      ))}
                      {customFonts.length === 0 && (
                        <p className="text-center text-gray-500 py-4">
                          No custom fonts uploaded yet. Go to Fonts tab to upload.
                        </p>
                      )}
                    </ScrollArea>
                  </div>
                  <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-800">
                      <strong>Note:</strong> Room admins can select from these fonts when customizing their room themes.
                      Unlimited fonts can be uploaded (recommended: keep under 50 for performance).
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
            )}

            {activeTab === 'games' && (
            <Card>
              <CardHeader>
                <div className="flex justify-between items-center">
                  <CardTitle>Games Management</CardTitle>
                  <Dialog open={createGameOpen} onOpenChange={setCreateGameOpen}>
                    <DialogTrigger asChild>
                      <Button data-testid="add-game-button">
                        <GamepadIcon className="w-4 h-4 mr-2" />
                        Add Game
                      </Button>
                    </DialogTrigger>
                    <DialogContent>
                      <DialogHeader>
                        <DialogTitle>Add New Game</DialogTitle>
                      </DialogHeader>
                      <div className="space-y-4">
                        <div>
                          <Label>Game Name</Label>
                          <Input
                            value={newGame.name}
                            onChange={(e) => setNewGame({ ...newGame, name: e.target.value })}
                            data-testid="game-name-input"
                          />
                        </div>
                        <div>
                          <Label>Game URL</Label>
                          <Input
                            value={newGame.url}
                            onChange={(e) => setNewGame({ ...newGame, url: e.target.value })}
                            placeholder="https://example.com/game.html"
                            data-testid="game-url-input"
                          />
                        </div>
                        <div>
                          <Label>Description (optional)</Label>
                          <Input
                            value={newGame.description}
                            onChange={(e) => setNewGame({ ...newGame, description: e.target.value })}
                            data-testid="game-description-input"
                          />
                        </div>
                        <Button onClick={createGame} className="w-full" data-testid="submit-game-button">
                          Add Game
                        </Button>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {games.map((game) => (
                    <div key={game.id} className="flex items-center justify-between p-3 border rounded-lg bg-white" data-testid={`game-${game.id}`}>
                      <div>
                        <p className="font-semibold">{game.name}</p>
                        <p className="text-sm text-gray-500 truncate max-w-md">{game.url}</p>
                      </div>
                      <Button
                        variant="destructive"
                        size="sm"
                        onClick={() => deleteGame(game.id)}
                        data-testid={`delete-game-${game.id}`}
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  ))}
                  {games.length === 0 && (
                    <p className="text-center text-gray-500 py-8">No games added yet</p>
                  )}
                </div>
              </CardContent>
            </Card>
            )}

            {activeTab === 'ads' && (
            <div className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle>External Ad Script Management</CardTitle>
                <p className="text-sm text-gray-600 mt-2">
                  Add ad scripts from external providers (AdSense, Adsterra, Bidvertiser, Advertica, etc.)
                  <br />
                  <strong className="text-amber-600">Note: Premium users are exempt from viewing ads.</strong>
                </p>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <Label>Ad Script Code</Label>
                    <Textarea
                      value={newAdScript.script_code}
                      onChange={(e) => setNewAdScript({...newAdScript, script_code: e.target.value})}
                      placeholder="Paste your ad script code here (e.g., <script>...</script>)"
                      rows={6}
                      className="font-mono text-sm"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Paste the complete script code provided by your ad network
                    </p>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label>Target Page</Label>
                      <select
                        className="w-full p-2 border rounded"
                        value={newAdScript.target_page}
                        onChange={(e) => setNewAdScript({...newAdScript, target_page: e.target.value})}
                      >
                        <option value="landing">Landing Page (Index)</option>
                        <option value="about">About Page</option>
                        <option value="contact">Contact/Feedback Page</option>
                        <option value="chat">Chat Page</option>
                        <option value="auth">Auth Page</option>
                        <option value="premium">Premium Page</option>
                      </select>
                    </div>
                    <div>
                      <Label>Position</Label>
                      <select
                        className="w-full p-2 border rounded"
                        value={newAdScript.position}
                        onChange={(e) => setNewAdScript({...newAdScript, position: e.target.value})}
                      >
                        <option value="header">Header (Top)</option>
                        <option value="sidebar">Sidebar</option>
                        <option value="footer">Footer (Bottom)</option>
                        <option value="inline">Inline (Content)</option>
                      </select>
                    </div>
                  </div>

                  <div className="flex gap-2">
                    <Button onClick={saveAdScript} className="flex-1">
                      <Save className="w-4 h-4 mr-2" />
                      Save Ad Script
                    </Button>
                    <Button 
                      onClick={() => applyUpdates('ad_scripts')}
                      disabled={applyingUpdates}
                      className="bg-blue-600 hover:bg-blue-700"
                    >
                      {applyingUpdates ? 'Applying...' : '🔄 Apply Updates'}
                    </Button>
                  </div>
                  <div className="text-sm text-blue-600 bg-blue-50 p-3 rounded mt-2">
                    💡 After adding/removing ad scripts, click "Apply Updates" to save changes. In production, ad script changes apply immediately via version polling.
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Installed Ad Scripts ({adScripts.length})</CardTitle>
              </CardHeader>
              <CardContent>
                <ScrollArea className="h-[400px]">
                  <div className="space-y-3">
                    {adScripts.map((script) => (
                      <div key={script.id} className="p-4 border rounded-lg bg-white shadow-sm">
                        {/* Action buttons FIRST - on the LEFT */}
                        <div className="flex items-start gap-3 mb-3">
                          <div className="flex flex-col gap-2 shrink-0">
                            <Button 
                              variant={script.is_active ? "outline" : "default"}
                              size="sm"
                              onClick={() => toggleAdScript(script.id, !script.is_active)}
                              className="flex items-center gap-1 w-20"
                              title={script.is_active ? "Deactivate" : "Activate"}
                            >
                              {script.is_active ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                              <span>{script.is_active ? 'Off' : 'On'}</span>
                            </Button>
                            <Button 
                              variant="destructive" 
                              size="sm"
                              onClick={() => deleteAdScript(script.id)}
                              className="flex items-center gap-1 w-20"
                              title="Delete this ad script"
                            >
                              <Trash2 className="w-4 h-4" />
                              <span>Delete</span>
                            </Button>
                          </div>
                          {/* Content on the right */}
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2 mb-2">
                              <Badge variant={script.is_active ? 'default' : 'secondary'}>
                                {script.is_active ? 'Active' : 'Inactive'}
                              </Badge>
                              <Badge variant="outline">{script.target_page}</Badge>
                              <Badge variant="outline">{script.position}</Badge>
                            </div>
                            <pre className="text-xs bg-gray-100 p-2 rounded max-h-20 overflow-auto">
                              {script.script_code?.substring(0, 150)}...
                            </pre>
                            <p className="text-xs text-gray-400 mt-1">
                              Added: {new Date(script.created_at).toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                    {adScripts.length === 0 && (
                      <p className="text-center text-gray-500 py-8">No ad scripts installed</p>
                    )}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Ad Display Rules</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="p-4 bg-gray-50 border rounded-lg">
                  <ul className="text-sm text-gray-700 space-y-2 list-disc list-inside">
                    <li>Ad scripts will be injected into the selected page at the specified position</li>
                    <li><strong className="text-green-600">Premium users will NOT see any ads</strong></li>
                    <li>Scripts are sanitized before injection for security</li>
                    <li>Toggle scripts on/off without deleting them</li>
                    <li>Changes take effect after page reload</li>
                  </ul>
                </div>
              </CardContent>
            </Card>
            </div>
            )}

            {activeTab === 'pmlogs' && (
            <Card>
              <CardHeader>
                <CardTitle>Private Message Logs</CardTitle>
                <p className="text-sm text-gray-600">Select a user → View their friends → View PM conversation</p>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 h-[600px]">
                  {/* User List - ALL USERS */}
                  <div className="border rounded-lg p-3 bg-gray-50">
                    <div className="flex justify-between items-center mb-3">
                      <h3 className="font-semibold">Users</h3>
                      <Button onClick={loadPmUsers} size="sm" variant="outline">
                        {pmUsersList.length > 0 ? 'Refresh' : 'Load Users'}
                      </Button>
                    </div>
                    <ScrollArea className="h-[520px]">
                      <div className="space-y-2">
                        {pmUsersList.map((user) => (
                          <div
                            key={user.id}
                            onClick={() => loadPmFriends(user.id)}
                            className={`p-2 rounded cursor-pointer hover:bg-white transition-colors ${
                              selectedPmUser === user.id ? 'bg-blue-100 border border-blue-300' : 'bg-white'
                            }`}
                          >
                            <p className="font-medium text-sm">{user.username}</p>
                            <p className="text-xs text-gray-500">{user.email}</p>
                            <Badge variant="outline" className="text-xs mt-1">{user.role}</Badge>
                          </div>
                        ))}
                        {pmUsersList.length === 0 && (
                          <p className="text-center text-gray-500 text-sm py-4">Click &quot;Load Users&quot; to start</p>
                        )}
                      </div>
                    </ScrollArea>
                  </div>

                  {/* Friends List */}
                  <div className="border rounded-lg p-3 bg-gray-50">
                    <h3 className="font-semibold mb-3">Friends/Connections</h3>
                    <ScrollArea className="h-[550px]">
                      <div className="space-y-2">
                        {pmFriendsList.map((friend) => (
                          <div
                            key={friend.id}
                            onClick={() => loadPmConversation(selectedPmUser, friend.id)}
                            className={`p-2 rounded cursor-pointer hover:bg-white transition-colors ${
                              selectedPmFriend === friend.id ? 'bg-blue-100 border border-blue-300' : 'bg-white'
                            }`}
                          >
                            <p className="font-medium text-sm">{friend.username}</p>
                            <p className="text-xs text-gray-500">{friend.message_count || 0} messages</p>
                          </div>
                        ))}
                        {pmFriendsList.length === 0 && (
                          <p className="text-center text-gray-500 text-sm py-8">
                            {selectedPmUser ? 'No friends found' : 'Select a user first'}
                          </p>
                        )}
                      </div>
                    </ScrollArea>
                  </div>

                  {/* Conversation */}
                  <div className="border rounded-lg p-3 bg-gray-50">
                    <h3 className="font-semibold mb-3">Conversation</h3>
                    <ScrollArea className="h-[550px]">
                      <div className="space-y-3">
                        {pmConversation.map((msg, idx) => (
                          <div key={msg.id || idx} className="p-2 rounded bg-white">
                            <div className="flex justify-between items-start mb-1">
                              <span className="text-xs font-semibold text-blue-600">{msg.sender?.username}</span>
                              <span className="text-xs text-gray-500">{new Date(msg.created_at).toLocaleTimeString()}</span>
                            </div>
                            <p className="text-sm text-gray-700">{msg.content}</p>
                          </div>
                        ))}
                        {pmConversation.length === 0 && selectedPmFriend && (
                          <div className="text-center py-12">
                            <MessageSquare className="w-12 h-12 mx-auto text-gray-400 mb-3" />
                            <p className="text-gray-600 font-medium">No PM conversation</p>
                            <p className="text-xs text-gray-500 mt-1">These users have not exchanged private messages</p>
                          </div>
                        )}
                        {pmConversation.length === 0 && !selectedPmFriend && (
                          <p className="text-center text-gray-500 text-sm py-8">
                            Select a friend to view conversation
                          </p>
                        )}
                      </div>
                    </ScrollArea>
                  </div>
                </div>
              </CardContent>
            </Card>
            )}

            

            {/* Avatars Management Tab */}
            {activeTab === 'avatars' && (
            <Card>
              <CardHeader>
                <CardTitle>Default Profile Avatars</CardTitle>
                <p className="text-sm text-gray-600 mt-2">
                  Upload default avatars that users can choose based on their gender
                </p>
              </CardHeader>
              <CardContent>
                <div className="w-full">
                  <div className="grid grid-cols-2 gap-2 mb-4">
                    <button
                      onClick={() => setAvatarTab('male')}
                      className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                        avatarTab === 'male'
                          ? 'bg-blue-600 text-white'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      Male Avatars ({maleAvatars.length})
                    </button>
                    <button
                      onClick={() => setAvatarTab('female')}
                      className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                        avatarTab === 'female'
                          ? 'bg-blue-600 text-white'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      Female Avatars ({femaleAvatars.length})
                    </button>
                  </div>
                  
                  {avatarTab === 'male' && (
                    <div className="space-y-4">
                      <div>
                        <Label>Upload Male Avatar</Label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => e.target.files[0] && uploadAvatar('male', e.target.files[0])}
                          disabled={uploadingAvatar}
                          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                        />
                      </div>
                      
                      <div className="grid grid-cols-4 gap-4">
                        {maleAvatars.map((avatar) => (
                          <div key={avatar.id} className="relative group">
                            <img
                              src={getImageUrl(avatar.avatar_url)}
                              alt="Male Avatar"
                              className="w-full h-24 object-cover rounded-lg border"
                            />
                            <Button
                              size="sm"
                              variant="destructive"
                              className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity"
                              onClick={() => deleteAvatar(avatar.id)}
                            >
                              <Trash2 className="w-3 h-3" />
                            </Button>
                          </div>
                        ))}
                      </div>
                      {maleAvatars.length === 0 && (
                        <p className="text-center text-gray-500 py-8">No male avatars uploaded yet</p>
                      )}
                    </div>
                  )}
                  
                  {avatarTab === 'female' && (
                    <div className="space-y-4">
                      <div>
                        <Label>Upload Female Avatar</Label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => e.target.files[0] && uploadAvatar('female', e.target.files[0])}
                          disabled={uploadingAvatar}
                          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-pink-50 file:text-pink-700 hover:file:bg-pink-100"
                        />
                      </div>
                      
                      <div className="grid grid-cols-4 gap-4">
                        {femaleAvatars.map((avatar) => (
                          <div key={avatar.id} className="relative group">
                            <img
                              src={getImageUrl(avatar.avatar_url)}
                              alt="Female Avatar"
                              className="w-full h-24 object-cover rounded-lg border"
                            />
                            <Button
                              size="sm"
                              variant="destructive"
                              className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity"
                              onClick={() => deleteAvatar(avatar.id)}
                            >
                              <Trash2 className="w-3 h-3" />
                            </Button>
                          </div>
                        ))}
                      </div>
                      {femaleAvatars.length === 0 && (
                        <p className="text-center text-gray-500 py-8">No female avatars uploaded yet</p>
                      )}
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
            )}

            {/* Index Page Content Tab */}
            

            {/* Premium Users Tab */}
            {activeTab === 'premium' && (
            <Card>
              <CardHeader>
                <CardTitle>Premium User Management</CardTitle>
                <p className="text-sm text-gray-600 mt-2">
                  View and manage premium users, or search to grant premium status
                </p>
              </CardHeader>
              <CardContent className="space-y-6">
                {/* Search Box to Find and Grant Premium */}
                <div className="space-y-2">
                  <Label>Search Users to Grant Premium Status</Label>
                  <div className="flex gap-2">
                    <Input
                      placeholder="Search by username, email, or ID..."
                      value={userSearchQuery}
                      onChange={(e) => setUserSearchQuery(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && searchUsers()}
                    />
                    <Button onClick={searchUsers}>
                      <Search className="w-4 h-4 mr-2" /> Search
                    </Button>
                  </div>
                  
                  {/* Search Results */}
                  {searchResults.length > 0 && (
                    <div className="space-y-2 mt-4">
                      <h3 className="font-semibold">Search Results ({searchResults.length})</h3>
                      {searchResults.map((user) => (
                        <div key={user.id} className="flex items-center justify-between p-4 border rounded-lg bg-white">
                          <div className="flex-1">
                            <div className="flex items-center gap-2">
                              <p className="font-semibold">{user.username}</p>
                              <Badge variant={user.role === 'premium' ? 'default' : 'secondary'}>
                                {user.role === 'premium' && <Crown className="w-3 h-3 mr-1" />}
                                {user.role}
                              </Badge>
                            </div>
                            <p className="text-sm text-gray-600">{user.email}</p>
                            <p className="text-xs text-gray-500">ID: {user.id}</p>
                          </div>
                          <Button
                            variant={user.role === 'premium' ? 'outline' : 'default'}
                            onClick={() => togglePremium(user.id, user.role)}
                          >
                            <Crown className="w-4 h-4 mr-2" />
                            {user.role === 'premium' ? 'Remove Premium' : 'Make Premium'}
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {searchResults.length === 0 && userSearchQuery && (
                    <p className="text-center text-gray-500 py-4">No users found</p>
                  )}
                </div>

                {/* Premium Requests Section */}
                <div className="border-t pt-4">
                  <h3 className="font-semibold mb-3 flex items-center gap-2">
                    <span className="text-lg">Pending Premium Requests ({premiumRequests.length})</span>
                    <Button onClick={loadPremiumRequests} variant="ghost" size="sm">
                      <Search className="w-4 h-4" />
                    </Button>
                  </h3>
                  {premiumRequests.length > 0 ? (
                    <div className="space-y-2">
                      {premiumRequests.map((request) => (
                        <div key={request.id} className="flex items-center justify-between p-4 border rounded-lg bg-blue-50">
                          <div className="flex-1">
                            <div className="flex items-center gap-2">
                              <p className="font-semibold">{request.username}</p>
                              <Badge variant="outline" className="bg-blue-100">
                                Pending
                              </Badge>
                            </div>
                            <p className="text-sm text-gray-600">{request.email}</p>
                            <p className="text-xs text-gray-500">User ID: {request.user_id}</p>
                            <p className="text-xs text-gray-500">Requested: {new Date(request.requested_at).toLocaleString()}</p>
                          </div>
                          <div className="flex gap-2">
                            <Button
                              variant="default"
                              className="bg-green-600 hover:bg-green-700"
                              onClick={() => approvePremiumRequest(request.id)}
                            >
                              <Crown className="w-4 h-4 mr-2" />
                              Approve
                            </Button>
                            <Button
                              variant="destructive"
                              onClick={() => rejectPremiumRequest(request.id)}
                            >
                              <Trash2 className="w-4 h-4 mr-2" />
                              Reject
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-center text-gray-500 py-8 bg-gray-50 rounded-lg">No pending premium requests</p>
                  )}
                </div>

                <div className="border-t pt-4">
                  <h3 className="font-semibold mb-3">Current Premium Users ({premiumUsers.length})</h3>
                  {premiumUsers.length > 0 ? (
                    <div className="space-y-2">
                      {premiumUsers.map((user) => (
                        <div key={user.id} className="flex items-center justify-between p-4 border rounded-lg bg-yellow-50">
                          <div className="flex-1">
                            <div className="flex items-center gap-2">
                              <p className="font-semibold">{user.username}</p>
                              <Badge variant="default" className="bg-yellow-500">
                                <Crown className="w-3 h-3 mr-1" />
                                Premium
                              </Badge>
                            </div>
                            <p className="text-sm text-gray-600">{user.email}</p>
                            <p className="text-xs text-gray-500">ID: {user.id}</p>
                          </div>
                          <Button
                            variant="destructive"
                            onClick={() => removePremiumStatus(user.id)}
                          >
                            <Trash2 className="w-4 h-4 mr-2" />
                            Remove Premium
                          </Button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-center text-gray-500 py-8">No premium users found</p>
                  )}
                </div>
              </CardContent>
            </Card>
            )}

            {/* Chat Logs Tab */}
            {activeTab === 'chatlogs' && (
            <Card>
              <CardHeader>
                <CardTitle>Chat Logs Search</CardTitle>
                <p className="text-sm text-gray-600 mt-2">
                  Search for a user and view their chat logs (public/private/PM)
                </p>
              </CardHeader>
              <CardContent className="space-y-4">
                {/* User Search */}
                <div className="space-y-2">
                  <Label>Search User</Label>
                  <div className="flex gap-2">
                    <Input
                      placeholder="Search by username..."
                      value={userSearchQuery}
                      onChange={(e) => setUserSearchQuery(e.target.value)}
                      className="flex-1"
                    />
                  </div>
                  
                  {/* Filtered User List */}
                  {allUsers.length > 0 && userSearchQuery && (
                    <div className="border rounded-lg p-2 bg-gray-50 max-h-60 overflow-y-auto">
                      <div className="space-y-1">
                        {allUsers
                          .filter(u => u.username?.toLowerCase().includes(userSearchQuery.toLowerCase()))
                          .slice(0, 10)
                          .map((user) => (
                            <div
                              key={user.id}
                              onClick={() => {
                                setLogSearchUserId(user.id);
                                searchChatLogs();
                              }}
                              className="p-2 hover:bg-white rounded cursor-pointer flex justify-between items-center"
                            >
                              <div>
                                <p className="font-medium text-sm">{user.username}</p>
                                <p className="text-xs text-gray-500">{user.email}</p>
                              </div>
                              <Badge variant="outline">{user.role}</Badge>
                            </div>
                        ))}
                        {allUsers.filter(u => u.username?.toLowerCase().includes(userSearchQuery.toLowerCase())).length === 0 && (
                          <p className="text-sm text-gray-500 text-center py-2">No users found</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                
                {chatLogs && (
                  <div className="space-y-4">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                      <h3 className="font-semibold">User Info</h3>
                      <p className="text-sm">Username: {chatLogs.user_info.username}</p>
                      <p className="text-sm">Email: {chatLogs.user_info.email}</p>
                      <p className="text-sm">Role: {chatLogs.user_info.role}</p>
                    </div>
                    
                    <div className="w-full">
                      <div className="grid grid-cols-2 gap-2 mb-4">
                        <button
                          onClick={() => setChatLogTab('public')}
                          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                            chatLogTab === 'public'
                              ? 'bg-blue-600 text-white'
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                        >
                          Public Messages ({chatLogs.public_messages.length})
                        </button>
                        <button
                          onClick={() => setChatLogTab('pms')}
                          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                            chatLogTab === 'pms'
                              ? 'bg-blue-600 text-white'
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                        >
                          Private Messages ({chatLogs.pms.length})
                        </button>
                      </div>
                      
                      {chatLogTab === 'public' && (
                        <ScrollArea className="h-96 border rounded-lg p-4">
                          {chatLogs.public_messages.length === 0 ? (
                            <p className="text-center text-gray-500 py-8">No public messages</p>
                          ) : (
                            chatLogs.public_messages.map((msg, idx) => (
                              <div key={idx} className="mb-3 p-3 border rounded bg-white">
                                <p className="text-xs text-gray-500">Room: {msg.room_name} | {new Date(msg.created_at).toLocaleString()}</p>
                                <p className="mt-1">{msg.content}</p>
                              </div>
                            ))
                          )}
                        </ScrollArea>
                      )}
                      
                      {chatLogTab === 'pms' && (
                        <ScrollArea className="h-96 border rounded-lg p-4">
                          {chatLogs.pms.length === 0 ? (
                            <p className="text-center text-gray-500 py-8">No private messages</p>
                          ) : (
                            chatLogs.pms.map((msg, idx) => (
                              <div key={idx} className="mb-3 p-3 border rounded bg-white">
                                <p className="text-xs text-gray-500">
                                  {msg.sender_id === logSearchUserId ? 'To' : 'From'}: {msg.other_user} | {new Date(msg.created_at).toLocaleString()}
                                </p>
                                <p className="mt-1">{msg.content}</p>
                              </div>
                            ))
                          )}
                        </ScrollArea>
                      )}
                    </div>
                  </div>
                )}
                
                {!chatLogs && (
                  <p className="text-center text-gray-500 py-8">Enter a user ID to search chat logs</p>
                )}
              </CardContent>
            </Card>
            )}

            {/* PHASE 6: System Health Tab */}
            {activeTab === 'system-health' && (
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Activity className="w-5 h-5" />
                    System Health Dashboard
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {loadingSystemHealth ? (
                    <div className="text-center py-8">
                      <p>Loading system health data...</p>
                    </div>
                  ) : systemHealthData ? (
                    <div className="space-y-6">
                      {/* System Resources */}
                      <div>
                        <h3 className="text-lg font-semibold mb-4">System Resources</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                          <Card>
                            <CardContent className="pt-6">
                              <div className="text-center">
                                <p className="text-sm text-gray-600">CPU Usage</p>
                                <p className="text-3xl font-bold text-blue-600">{systemHealthData.system?.cpu_percent || 0}%</p>
                              </div>
                            </CardContent>
                          </Card>
                          <Card>
                            <CardContent className="pt-6">
                              <div className="text-center">
                                <p className="text-sm text-gray-600">Memory Usage</p>
                                <p className="text-3xl font-bold text-green-600">{systemHealthData.system?.memory_percent || 0}%</p>
                                <p className="text-xs text-gray-500 mt-1">
                                  {systemHealthData.system?.memory_used_gb || 0} GB / {systemHealthData.system?.memory_total_gb || 0} GB
                                </p>
                              </div>
                            </CardContent>
                          </Card>
                          <Card>
                            <CardContent className="pt-6">
                              <div className="text-center">
                                <p className="text-sm text-gray-600">Disk Usage</p>
                                <p className="text-3xl font-bold text-orange-600">{systemHealthData.system?.disk_percent || 0}%</p>
                                <p className="text-xs text-gray-500 mt-1">
                                  {systemHealthData.system?.disk_used_gb || 0} GB / {systemHealthData.system?.disk_total_gb || 0} GB
                                </p>
                              </div>
                            </CardContent>
                          </Card>
                          <Card>
                            <CardContent className="pt-6">
                              <div className="text-center">
                                <p className="text-sm text-gray-600">Uptime</p>
                                <p className="text-3xl font-bold text-purple-600">{systemHealthData.system?.uptime_hours || 0}h</p>
                              </div>
                            </CardContent>
                          </Card>
                        </div>
                      </div>

                      {/* Application Metrics */}
                      <div>
                        <h3 className="text-lg font-semibold mb-4">Application Metrics</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <Card>
                            <CardContent className="pt-6">
                              <p className="text-sm text-gray-600">Total Requests</p>
                              <p className="text-2xl font-bold">{systemHealthData.application?.total_requests || 0}</p>
                            </CardContent>
                          </Card>
                          <Card>
                            <CardContent className="pt-6">
                              <p className="text-sm text-gray-600">Error Rate</p>
                              <p className="text-2xl font-bold text-red-600">{systemHealthData.application?.error_rate_percent || 0}%</p>
                            </CardContent>
                          </Card>
                          <Card>
                            <CardContent className="pt-6">
                              <p className="text-sm text-gray-600">Active Connections</p>
                              <p className="text-2xl font-bold text-blue-600">{systemHealthData.application?.active_connections || 0}</p>
                              <p className="text-xs text-gray-500">Peak: {systemHealthData.application?.peak_connections || 0}</p>
                            </CardContent>
                          </Card>
                        </div>
                      </div>

                      {/* Services Status */}
                      <div>
                        <h3 className="text-lg font-semibold mb-4">Services Status</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          {systemHealthData.services && Object.entries(systemHealthData.services).map(([service, status]) => (
                            <Card key={service}>
                              <CardContent className="pt-6">
                                <div className="flex items-center justify-between">
                                  <span className="font-medium capitalize">{service}</span>
                                  <Badge variant={status === 'running' ? 'default' : 'destructive'}>
                                    {status}
                                  </Badge>
                                </div>
                              </CardContent>
                            </Card>
                          ))}
                        </div>
                      </div>

                      <div className="flex justify-end">
                        <Button onClick={loadSystemHealth} variant="outline">
                          <Activity className="w-4 h-4 mr-2" />
                          Refresh
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <p className="text-center text-gray-500 py-8">No system health data available</p>
                  )}
                </CardContent>
              </Card>
            )}

            {/* PHASE 4: Media Security Tab */}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
